(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cx-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
  const configElement = document.getElementById('cx-config');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const previewTheme = window.Shopify?.theme;
  const previewThemeId = previewTheme && ['unpublished','development','demo'].includes(previewTheme.role) ? String(previewTheme.id) : '';

  const drawer = document.getElementById('cx-cart-drawer');
  let cartBusy = false;
  let cartNeedsReload = false;
  let planFeedback = '';
  let returnFocus = null;
  let draftDiscount = null;
  let discountFeedback = null;
  const normalizeDiscounts = value => [...new Set(String(value || '').split(',').map(code => code.trim().toUpperCase()).filter(Boolean))].join(',');
  async function prepareCheckout(value) {
    await window.CxCartCleanup.ensure(config);
    if (value === null || value === undefined) return;
    const codes = normalizeDiscounts(value);
    await request(config.update, {discount: codes});
    draftDiscount = codes;
  }
  const regions = () => [...document.querySelectorAll('[data-cx-cart-region]')];
  const sectionIds = () => [...new Set(regions().map(el => el.dataset.sectionId))];
  function syncCartPlanControls() {
    document.querySelectorAll('[data-cx-plan-controls]').forEach(control => { control.hidden = false; });
    document.querySelectorAll('[data-cx-plan-status]').forEach(status => { status.textContent = planFeedback; });
    document.querySelectorAll('[data-cx-plan-reload]').forEach(link => { link.hidden = !cartNeedsReload; });
    document.documentElement?.toggleAttribute('data-cx-cart-needs-reload', cartNeedsReload);
  }
  function syncDiscountFeedback() {
    document.querySelectorAll('[data-cx-code-actions]').forEach(actions => { actions.hidden = false; });
    document.querySelectorAll('[data-cx-cart-content]').forEach(content => {
      const status = content.querySelector('[data-cx-code-status]');
      if (!status || !discountFeedback) return;
      if (discountFeedback.kind !== 'result') {
        status.textContent = discountFeedback.message;
        return;
      }
      const requested = normalizeDiscounts(discountFeedback.codes).split(',').filter(Boolean);
      const confirmed = normalizeDiscounts(content.dataset.cxAppliedCodes).split(',').filter(Boolean);
      const applied = requested.filter(code => confirmed.includes(code));
      const missing = requested.filter(code => !confirmed.includes(code));
      const messages = [];
      if (!requested.length) messages.push(confirmed.length ? config.codeError : config.codeCleared);
      if (applied.length) messages.push(config.codeApplied.replace('__codes__', applied.join(', ')));
      if (missing.length) messages.push(config.codeNotApplied.replace('__codes__', missing.join(', ')), config.codeEligibility);
      status.textContent = messages.join(' ');
    });
  }
  async function applyCartCodes(form, clear = false) {
    if (cartBusy || cartNeedsReload || !form) return;
    const input = form.querySelector('[name="discount"]');
    if (!input) return;
    const codes = clear ? '' : normalizeDiscounts(input.value);
    if (!clear && !codes) {
      discountFeedback = {kind:'message', message:config.codeEmpty};
      syncDiscountFeedback();
      input.focus();
      return;
    }
    const activeRegion = form.closest('[data-cx-cart-region]');
    const previous = regions().map(region => [region, region.querySelector('[data-cx-cart-content]')]);
    const refreshed = () => previous.length > 0 && previous.every(([region, content]) => region.querySelector('[data-cx-cart-content]') !== content);
    draftDiscount = codes;
    document.querySelectorAll('[data-cx-cart-form] [name="discount"]').forEach(field => { field.value = codes; });
    discountFeedback = {kind:'message', message:config.codeApplying};
    syncDiscountFeedback();
    busyCart(true);
    showError('', form);
    let saved = false;
    try {
      await window.CxCartCleanup.ensure(config);
      const data = await request(config.update, {discount:codes});
      saved = true;
      renderSections(data);
      if (!refreshed()) await refreshCart();
      if (!refreshed()) throw new Error(config.codeRefreshError);
      discountFeedback = {kind:'result', codes};
    } catch (_) {
      discountFeedback = {kind:'message', message:saved ? config.codeRefreshError : config.codeError};
    } finally {
      busyCart(false);
      syncDiscountFeedback();
      const focusTarget = activeRegion?.querySelector('[data-cx-code-status]') || form.querySelector('[data-cx-code-status]');
      const feedbackDetails = focusTarget?.closest('details');
      if (feedbackDetails) feedbackDetails.open = true;
      focusTarget?.focus({preventScroll:true});
    }
  }
  function openDrawer(trigger) {
    if (!drawer || typeof drawer.showModal !== 'function') { location.assign(config.cart); return; }
    if (!drawer.open) returnFocus = trigger || document.activeElement;
    document.querySelector('.cx-mobile-menu')?.removeAttribute('open'); document.querySelector('[data-merge-menu]')?.removeAttribute('open');
    if (!drawer.open) drawer.showModal();
  }
  function closeDrawer() { drawer?.close(); returnFocus?.focus(); }
  function showError(message, form) {
    const target = form?.querySelector('[data-cx-form-status]') || form?.querySelector('[data-cx-cart-error]') || (drawer?.open && drawer.querySelector('[data-cx-cart-error]')) || document.querySelector('[data-cx-cart-error]');
    if (target) target.textContent = typeof message === 'string' ? message : config.error;
  }
  function syncDiscoveryForms() {
    const kitInCart = !!document.querySelector('[data-cx-discovery-line]');
    document.querySelectorAll('[data-cx-discovery-form]').forEach(form => {
      const button = form.querySelector('[data-cx-add]');
      if (!button || form.dataset.busy) return;
      const available = form.dataset.cxKitAvailable === 'true';
      button.disabled = !available || kitInCart;
      const label = button.querySelector('span');
      if (label && available) label.textContent = kitInCart ? form.dataset.cxKitInCart : form.dataset.cxKitLabel;
      const viewCart = form.parentElement.querySelector('[data-cx-kit-view-cart]');
      if (viewCart) viewCart.hidden = !kitInCart;
    });
  }
  function renderSections(response) {
    if (!response.sections) return false;
    let changed = false;
    regions().forEach(region => {
      const html = response.sections[region.dataset.sectionId];
      if (!html) return;
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const content = documentFragment.querySelector('[data-cx-cart-content]');
      if (!content || (previewThemeId && content.dataset.cxRenderTheme !== previewThemeId)) return;
      const previousScrollTop = region.querySelector('[data-cx-cart-scroll]')?.scrollTop;
      const discountWasOpen = region.querySelector('.cx-code')?.open;
      region.replaceChildren(content);
      const scrollArea = content.querySelector('[data-cx-cart-scroll]');
      if (scrollArea && previousScrollTop !== undefined) scrollArea.scrollTop = previousScrollTop;
      const discountDisclosure = content.querySelector('.cx-code');
      if (discountDisclosure && discountWasOpen !== undefined) discountDisclosure.open = discountWasOpen;
      if (draftDiscount !== null) {
        const discountInput = content.querySelector('[name="discount"]');
        if (discountInput) discountInput.value = draftDiscount;
      }
      document.querySelectorAll('[data-cx-count]').forEach(el => { el.textContent = content.dataset.itemCount; });
      changed = true;
    });
    if (changed) { syncDiscoveryForms(); syncDiscountFeedback(); syncCartPlanControls(); }
    return changed;
  }
  async function request(url, body) {
    const response = await fetch(url + '.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({...body, sections:sectionIds(), sections_url:location.pathname})});
    const data = await response.json();
    if (!response.ok) {
      const error = new Error(data.description || data.message || config.error);
      error.cartRejected = true;
      throw error;
    }
    return data;
  }
  async function refreshCart() {
    const url = new URL(location.href);
    if (previewThemeId) {
      url.searchParams.delete('sections');
      url.searchParams.set('preview_theme_id', previewThemeId);
      const response = await fetch(url.toString(), {headers:{Accept:'text/html'},credentials:'same-origin',cache:'no-store'});
      if (!response.ok) throw new Error(config.error);
      const preview = new DOMParser().parseFromString(await response.text(), 'text/html');
      const sections = {};
      preview.querySelectorAll('[data-cx-cart-region]').forEach(region => { sections[region.dataset.sectionId] = region.innerHTML; });
      return renderSections({sections});
    }
    url.searchParams.set('sections', sectionIds().join(','));
    const response = await fetch(url, {headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error(config.error);
    return renderSections({sections:await response.json()});
  }
  function busyCart(value) {
    cartBusy = value;
    document.querySelectorAll('[data-cx-cart-form] button,[data-cx-cart-form] input').forEach(el => { el.disabled = value || cartNeedsReload || (el.matches('[data-cx-qty="1"]') && !!el.closest('[data-cx-discovery-line]')); });
    document.querySelectorAll('[data-cx-cart-content]').forEach(el => { el.setAttribute('aria-busy', String(value)); });
  }
  async function updateQuantity(line, quantity) {
    if (cartBusy || cartNeedsReload || !line || !Number.isInteger(quantity) || quantity < 0) return;
    const form = line.closest('form');
    const region = line.closest('[data-cx-cart-region]');
    const focused = document.activeElement;
    const restoreFocus = line.contains(focused) && focused.matches('[data-cx-qty],[data-cx-qty-input],[data-cx-remove]');
    const lineIndex = region ? [...region.querySelectorAll('[data-cx-line]')].indexOf(line) : -1;
    const previous = regions().map(part => [part, part.querySelector('[data-cx-cart-content]')]);
    const refreshed = () => previous.length > 0 && previous.every(([part, content]) => part.querySelector('[data-cx-cart-content]') !== content);
    const focusSelector = focused?.matches('[data-cx-remove]') ? '[data-cx-remove]' : focused?.matches('[data-cx-qty-input]') ? '[data-cx-qty-input]' : focused?.matches('[data-cx-qty="1"]') ? '[data-cx-qty="1"]' : '[data-cx-qty="-1"]';
    if (line.hasAttribute('data-cx-discovery-line')) quantity = Math.min(1, quantity);
    let saved = false;
    busyCart(true);
    try {
      const data = await request(config.change, {id:line.dataset.key, quantity});
      saved = true;
      renderSections(data);
      if (!refreshed()) await refreshCart();
      if (!refreshed()) location.assign(config.cart);
    } catch (error) {
      if (saved) location.assign(config.cart);
      else { form?.querySelectorAll('[data-cx-qty-input]').forEach(input => { input.value = input.defaultValue; }); showError(error.message, form); }
    }
    finally {
      busyCart(false);
      const active = document.activeElement;
      // Restore a replaced control without taking focus back from another part of the page.
      if (restoreFocus && region?.isConnected && (active === focused || active === document.body || active === drawer)) {
        const lines = [...region.querySelectorAll('[data-cx-line]')];
        const remaining = lines.find(item => item.dataset.key === line.dataset.key) || lines[Math.min(lineIndex, lines.length - 1)];
        const target = remaining?.querySelector(focusSelector + ':not(:disabled)') || remaining?.querySelector('[data-cx-qty-input]') || region.querySelector('.cx-cart-empty a[href]');
        target?.focus({preventScroll:true});
      }
    }
  }
  async function updateSellingPlan(button) {
    if (cartBusy || cartNeedsReload || button.disabled || !button.isConnected) return;
    const line = button.closest('[data-cx-line]');
    const region = button.closest('[data-cx-cart-region]');
    const requested = button.dataset.cxPlanChange;
    const targetPlan = requested === '' ? null : Number(requested);
    if (!line || !region || (targetPlan === null ? line.dataset.cxAllowOnce !== 'true' : !Number.isSafeInteger(targetPlan) || targetPlan <= 0 || requested !== line.dataset.cxAllowedPlan)) return;
    const expectedPlan = line.dataset.cxCurrentPlan || '';
    if (String(targetPlan || '') === expectedPlan) return;
    const focused = document.activeElement;
    const restoreFocus = line.contains(focused);
    const previous = regions().map(part => [part, part.querySelector('[data-cx-cart-content]')]);
    const refreshed = () => previous.length > 0 && previous.every(([part, content]) => part.querySelector('[data-cx-cart-content]') !== content);
    const getPlan = item => String(item.selling_plan_allocation?.selling_plan?.id || '');
    const propertiesKey = item => JSON.stringify(Object.entries(item.properties || {}).sort(([a], [b]) => a.localeCompare(b)));
    let mutationAttempted = false;
    let saved = false;
    busyCart(true);
    planFeedback = config.planUpdating;
    syncCartPlanControls();
    showError('', line.closest('form'));
    try {
      const response = await fetch(config.cart + '.js', {headers:{Accept:'application/json'}, cache:'no-store'});
      if (!response.ok) throw new Error(config.planError);
      const current = await response.json();
      if (!Array.isArray(current.items)) throw new Error(config.planError);
      const index = current.items.findIndex(item => item.key === line.dataset.key);
      const item = current.items[index];
      if (!item || String(item.variant_id) !== line.dataset.cxVariantId || item.quantity !== Number(line.dataset.cxQuantity) || getPlan(item) !== expectedPlan) {
        cartNeedsReload = true;
        await refreshCart();
        if (refreshed()) { cartNeedsReload = false; planFeedback = config.planChanged; }
        else planFeedback = config.planRefreshError;
        return;
      }
      const signature = propertiesKey(item);
      const groupQuantity = (items, plan) => items.filter(entry => entry.variant_id === item.variant_id && getPlan(entry) === plan && propertiesKey(entry) === signature).reduce((sum, entry) => sum + entry.quantity, 0);
      const target = String(targetPlan || '');
      const targetBefore = groupQuantity(current.items, target);
      const sourceBefore = groupQuantity(current.items, expectedPlan);
      mutationAttempted = true;
      const data = await request(config.change, {line:index + 1, quantity:item.quantity, selling_plan:targetPlan});
      saved = true;
      if (!Array.isArray(data.items) || groupQuantity(data.items, target) !== targetBefore + item.quantity || groupQuantity(data.items, expectedPlan) !== sourceBefore - item.quantity) throw new Error(config.planRefreshError);
      renderSections(data);
      if (!refreshed()) await refreshCart();
      if (!refreshed()) throw new Error(config.planRefreshError);
      planFeedback = targetPlan === null ? config.planOnce : config.planMonthly;
    } catch (error) {
      if (saved || (mutationAttempted && !error.cartRejected) || cartNeedsReload) {
        cartNeedsReload = true;
        planFeedback = config.planRefreshError;
      } else planFeedback = config.planError;
    } finally {
      busyCart(false);
      syncCartPlanControls();
      const active = document.activeElement;
      if (restoreFocus && region.isConnected && (active === focused || active === document.body || active === drawer)) {
        const target = region.querySelector('[data-cx-plan-status]') || region.querySelector('.cx-cart-empty a[href]');
        target?.focus({preventScroll:true});
      }
    }
  }
  async function addCrossSell(button) {
    if (cartBusy || cartNeedsReload || button.disabled || !button.isConnected) return;
    const variantId = Number(button.dataset.variantId);
    const region = button.closest('[data-cx-cart-region]');
    if (!region || !Number.isSafeInteger(variantId) || variantId <= 0) return;
    const original = button.innerHTML;
    const restoreFocus = document.activeElement === button;
    const discountInput = region.querySelector('[name="discount"]');
    if (discountInput) draftDiscount = discountInput.value;
    const showStatus = message => {
      const status = region.querySelector('[data-cx-cross-sell-status]') || region.querySelector('[data-cx-cart-error]');
      if (status) status.textContent = typeof message === 'string' ? message : config.error;
    };
    let itemAdded = false;
    busyCart(true);
    button.textContent = config.adding;
    showStatus('');
    try {
      await window.CxCartCleanup.ensure(config).catch(() => { throw new Error(config.error); });
      const data = await request(config.add, {items:[{id:variantId, quantity:1}]});
      itemAdded = true;
      const previousContent = region.querySelector('[data-cx-cart-content]');
      const scrollTop = drawer?.scrollTop;
      renderSections(data);
      if (region.querySelector('[data-cx-cart-content]') === previousContent) await refreshCart();
      if (region.querySelector('[data-cx-cart-content]') === previousContent) { location.assign(config.cart); return; }
      showStatus(config.added);
      if (drawer?.open) {
        if (restoreFocus && !button.isConnected && (document.activeElement === document.body || document.activeElement === drawer)) {
          const target = drawer.querySelector('[data-cx-cross-sell-heading]') || drawer.querySelector('#cx-drawer-title');
          if (target) { target.tabIndex = -1; target.focus({preventScroll:true}); }
        }
        drawer.scrollTop = scrollTop;
      }
    } catch (error) {
      if (itemAdded) location.assign(config.cart);
      else showStatus(error.message);
    } finally {
      busyCart(false);
      if (button.isConnected) button.innerHTML = original;
    }
  }
  document.addEventListener('click', async event => {
    const checkoutLink = event.target.closest('a[href]');
    if (checkoutLink) {
      const destination = new URL(checkoutLink.href, location.href);
      if (destination.origin === location.origin && /\/checkout\/?$/.test(destination.pathname)) {
        event.preventDefault();
        if (cartBusy || cartNeedsReload) { if (cartNeedsReload) showError(config.planRefreshError); return; }
        busyCart(true);
        try {
          const codeInput = drawer?.open ? drawer.querySelector('[name="discount"]') : document.querySelector('[data-cx-cart-form] [name="discount"]');
          const codes = draftDiscount !== null ? draftDiscount : destination.searchParams.has('discount') ? destination.searchParams.get('discount') : codeInput?.value;
          await prepareCheckout(codes);
          if (codes !== null && codes !== undefined) {
            const normalized = normalizeDiscounts(codes);
            if (normalized) destination.searchParams.set('discount', normalized);
            else destination.searchParams.delete('discount');
          }
          location.assign(destination.href);
        }
        catch (_) { showError(config.error); }
        finally { busyCart(false); }
        return;
      }
    }
    const applyCodes = event.target.closest('[data-cx-code-apply]');
    const clearCodes = event.target.closest('[data-cx-code-clear]');
    if (applyCodes || clearCodes) { event.preventDefault(); await applyCartCodes((applyCodes || clearCodes).closest('[data-cx-cart-form]'), !!clearCodes); return; }
    const planButton = event.target.closest('[data-cx-plan-change]');
    if (planButton) { event.preventDefault(); await updateSellingPlan(planButton); return; }
    const open = event.target.closest('[data-cx-cart-open]');
    if (open) { event.preventDefault(); openDrawer(open); if (!cartBusy) { busyCart(true); try { await window.CxCartCleanup.ensure(config); await refreshCart(); } catch (_) { showError(config.error); } finally { busyCart(false); } } return; }
    if (event.target.closest('[data-cx-cart-close]')) { closeDrawer(); return; }
    const crossSellButton = event.target.closest('[data-cx-cross-sell-add]');
    if (crossSellButton) { event.preventDefault(); await addCrossSell(crossSellButton); return; }
    const quantityButton = event.target.closest('[data-cx-qty]');
    if (quantityButton) {
      const line = quantityButton.closest('[data-cx-line]');
      const input = line.querySelector('[data-cx-qty-input]');
      updateQuantity(line, Math.max(0,Number(input.value) + Number(quantityButton.dataset.cxQty)));
      return;
    }
    const remove = event.target.closest('[data-cx-remove]');
    if (remove) updateQuantity(remove.closest('[data-cx-line]'),0);
    if (drawer && event.target === drawer) closeDrawer();
  });
  document.addEventListener('input', event => {
    if (event.target.matches('[data-cx-cart-form] [name="discount"]')) {
      draftDiscount = event.target.value;
      discountFeedback = {kind:'message', message:config.codePending};
      syncDiscountFeedback();
      document.querySelectorAll('[data-cx-cart-form] [name="discount"]').forEach(input => { if (input !== event.target) input.value = draftDiscount; });
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Enter' && event.target.matches('[data-cx-cart-form] [name="discount"]')) {
      event.preventDefault();
      applyCartCodes(event.target.closest('[data-cx-cart-form]'));
    }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-cx-qty-input]')) updateQuantity(event.target.closest('[data-cx-line]'),Number(event.target.value));
  });
  // Shopify's web pixels count a product form submit as an add to cart unless it is already
  // cancelled when their listener on the form runs; cancel it there, before the cart request.
  const guardedForms = new WeakSet();
  const guardProductForms = root => {
    const forms = root.matches?.('form.cx-product-form') ? [root] : [...(root.querySelectorAll?.('form.cx-product-form') || [])];
    forms.forEach(form => {
      if (guardedForms.has(form)) return;
      guardedForms.add(form);
      form.addEventListener('submit', event => event.preventDefault(), true);
    });
  };
  guardProductForms(document);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => { if (node.nodeType === 1) guardProductForms(node); }))).observe(document.documentElement, {childList:true, subtree:true});
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (form.matches('[data-cx-cart-form]')) {
      if (cartBusy || cartNeedsReload) { event.preventDefault(); if (cartNeedsReload) showError(config.planRefreshError, form); return; }
      if (event.submitter?.name !== 'checkout') return;
      event.preventDefault();
      const code = normalizeDiscounts(form.querySelector('[name="discount"]')?.value);
      busyCart(true);
      showError('', form);
      try {
        await prepareCheckout(code);
        const destination = config.root.replace(/\/$/, '') + '/checkout?locale=' + encodeURIComponent(config.locale) + (code ? '&discount=' + encodeURIComponent(code) : '');
        location.assign(destination);
      } catch (_) { showError(config.error, form); }
      finally { busyCart(false); }
      return;
    }
    if (!form.matches('.cx-product-form')) return;
    event.preventDefault();
    if (form.dataset.busy || cartBusy || cartNeedsReload) { if (cartNeedsReload) showError(config.planRefreshError, form); return; }
    const formData = new FormData(form);
    const item = {id:Number(formData.get('id')),quantity:Number(formData.get('quantity') || 1)};
    if (formData.get('selling_plan')) item.selling_plan = Number(formData.get('selling_plan'));
    const properties = {};
    for (const [key,value] of formData.entries()) { const match = key.match(/^properties\[(.+)\]$/); if (match && value && match[1] !== 'Preorder' && match[1] !== '_preorder') properties[match[1]] = value; }
    if (Object.keys(properties).length) item.properties = properties;
    const button = event.submitter || form.querySelector('[type="submit"]');
    const original = button?.innerHTML;
    form.dataset.busy = 'true';
    if (button) { button.disabled = true; button.textContent = config.adding; }
    showError('',form);
    let itemAdded = false;
    busyCart(true);
    try {
      await window.CxCartCleanup.ensure(config).catch(() => { throw new Error(config.error); });
      if (form.hasAttribute('data-cx-discovery-form')) {
        const cartResponse = await fetch(config.cart + '.js', {headers:{Accept:'application/json'}});
        if (!cartResponse.ok) throw new Error(config.error);
        const existingCart = await cartResponse.json();
        if (existingCart.items.some(line => line.variant_id === item.id)) throw new Error(config.kitLimit);
        item.quantity = 1;
      }
      const data = await request(config.add,{items:[item]});
      itemAdded = true;
      if (!renderSections(data) && !await refreshCart()) { location.assign(config.cart); return; }
      showError(config.added,form);
      openDrawer(button);
    } catch (error) { if (itemAdded) { location.assign(config.cart); } else { showError(error.message,form); } }
    finally { busyCart(false); delete form.dataset.busy; if (button) { button.disabled = false; button.innerHTML = original; } form.dispatchEvent(new Event('cx:purchase-updated')); syncDiscoveryForms(); }
  });
  syncDiscountFeedback();
  syncCartPlanControls();
  document.addEventListener('click', event => { const menu = document.querySelector('[data-merge-menu]'); if (menu?.open && !menu.contains(event.target)) menu.removeAttribute('open'); });
  document.addEventListener('click', event => { const language = document.querySelector('[data-cx-language]'); if (language?.open && !language.contains(event.target)) language.removeAttribute('open'); });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const language = document.querySelector('[data-cx-language]');
    if (language?.open) { language.removeAttribute('open'); language.querySelector('summary')?.focus(); }
    document.querySelector('.cx-mobile-menu')?.removeAttribute('open');
    const menu = document.querySelector('[data-merge-menu]');
    if (menu?.open) { menu.removeAttribute('open'); menu.querySelector('summary')?.focus(); }
  });
  document.addEventListener('click', event => { const menu = document.querySelector('.cx-mobile-menu'); if (menu?.open && !menu.contains(event.target)) menu.removeAttribute('open'); });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cx-card-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cx-card-purchase')) {
  customElements.define('cx-card-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.form = this.querySelector('form');
      this.options = this.querySelector('fieldset');
      this.select = this.querySelector('select[name="selling_plan"]');
      this.button = this.querySelector('button[type="submit"]');
      if ((!this.options && !this.select) || !this.button) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.inline = this.hasAttribute('data-always-open');
      this.setAttribute('data-enhanced', '');
      this.pointerType = '';
      this.open = this.inline;
      this.setOpen(this.open);
      this.syncPrice();
      this.addEventListener('change', () => this.syncPrice(), {signal});
      this.form.addEventListener('cx:purchase-updated', () => this.syncPrice(), {signal});
      window.addEventListener('pageshow', () => this.syncPrice(), {signal});
      if (this.inline) return;
      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') this.setOpen(true);
      }, {signal});
      this.addEventListener('pointerleave', event => {
        if (event.pointerType === 'mouse' && !this.contains(document.activeElement)) this.setOpen(false);
      }, {signal});
      this.addEventListener('pointerdown', event => {
        this.pointerType = event.pointerType;
      }, {signal});
      this.addEventListener('focusin', () => {
        if (this.pointerType !== 'touch' && this.pointerType !== 'pen') this.setOpen(true);
      }, {signal});
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) this.setOpen(false);
      }, {signal});
      this.addEventListener('keydown', event => {
        this.pointerType = '';
        if (event.key === 'Escape' && this.open && !this.inline) {
          event.preventDefault();
          event.stopPropagation();
          this.button.focus();
          this.setOpen(false);
        } else if (event.target === this.button && event.key === 'ArrowUp') {
          event.preventDefault();
          this.setOpen(true);
          this.options.querySelector('input:checked')?.focus();
        }
      }, {signal});
      this.form.addEventListener('submit', event => {
        if (!this.open && !this.inline) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.setOpen(true);
        }
      }, {capture: true, signal});
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) this.setOpen(false);
      }, {signal});
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
    setOpen(value) {
      this.open = this.inline || value;
      this.toggleAttribute('data-open', this.open);
      if (!this.inline) this.button.setAttribute('aria-expanded', String(this.open));
    }
    syncPrice() {
      const selected = this.select?.selectedOptions[0] || this.options?.querySelector('input:checked');
      if (!selected) return;
      const subscription = Boolean(selected.value);
      const label = subscription ? this.dataset.subLabel : this.dataset.onceLabel;
      const price = selected.dataset.price;
      const period = subscription ? this.dataset.monthLabel : '';
      if (!this.button.disabled) {
        const total = this.button.querySelector('[data-cx-add-price]');
        if (total) total.textContent = price;
        this.button.setAttribute('aria-label', `${this.dataset.addLabel} — ${this.dataset.productTitle} — ${price} ${period} — ${label}`);
      }
      const scope = this.closest('[data-cx-purchase-scope]');
      scope?.querySelectorAll('[data-cx-card-price]').forEach(node => node.textContent = price);
      scope?.querySelectorAll('[data-cx-card-period]').forEach(node => {node.textContent = period;node.hidden = !subscription;});
      scope?.querySelectorAll('[data-cx-card-plan-label]').forEach(node => node.textContent = label);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cx-discovery-interest"] && !Shopify.designMode) return;
  try {
    (() => {
  const forms = document.querySelectorAll('[data-cx-discovery-interest-form]');
  forms.forEach(form => {
    if (form.dataset.cxInterestReady) return;
    form.dataset.cxInterestReady = 'true';
    const details = form.querySelector('[data-cx-discovery-interest-details]');
    const result = form.querySelector('[data-cx-discovery-interest-result]');
    const button = form.querySelector('[data-cx-discovery-interest-submit]');
    const status = form.querySelector('[data-cx-discovery-interest-pending]');
    if (details && 'IntersectionObserver' in window) {
      details.toggleAttribute('data-cx-interest-observed', true);
      const visibility = new IntersectionObserver(entries => {
        entries.forEach(entry => details.toggleAttribute('data-cx-interest-visible', entry.isIntersecting));
      }, { threshold: 0 });
      visibility.observe(details);
      const unload = event => {
        if (!event.target.contains(form)) return;
        visibility.disconnect();
        details.removeAttribute('data-cx-interest-observed');
        details.removeAttribute('data-cx-interest-visible');
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    }
    const resetPending = () => {
      form.removeAttribute('aria-busy');
      delete form.dataset.cxInterestPending;
      if (button) button.disabled = false;
      if (status) status.textContent = '';
    };
    const openFromHash = () => {
      const target = location.hash.slice(1);
      if (target !== form.id && target !== 'CxDiscoveryInterest') return;
      if (details) details.open = true;
      (result || form.querySelector('input[type="email"]'))?.focus({preventScroll: true});
    };
    if (result) {
      if (details) details.open = true;
      result.focus({preventScroll: true});
    }
    openFromHash();
    window.addEventListener('hashchange', openFromHash);
    window.addEventListener('pageshow', resetPending);
    form.addEventListener('submit', event => {
      if (form.dataset.cxInterestPending === 'true') {
        event.preventDefault();
        return;
      }
      queueMicrotask(() => {
        if (event.defaultPrevented) return;
        form.dataset.cxInterestPending = 'true';
        form.setAttribute('aria-busy', 'true');
        if (button) button.disabled = true;
        if (status) status.textContent = form.dataset.pendingLabel;
      });
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cx-email-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const popup = document.getElementById('cx-email-popup');
  if (!popup || typeof popup.showModal !== 'function') return;
  const form = popup.querySelector('#cx-popup-form');
  if (!form || popup.dataset.cxWelcomeReady === 'true') return;
  popup.dataset.cxWelcomeReady = 'true';
  let trigger = '';
  const result = popup.querySelector('[data-cx-popup-result]')?.dataset.cxPopupResult || '';
  const prefix = 'cx-email-popup-v1:';
  const delay = Math.max(5, Math.min(60, Number(popup.dataset.delay) || 10)) * 1000;
  const day = 86400000;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const read = (area, key) => {
    try { return Number(window[area].getItem(prefix + key)) || 0; } catch { return 0; }
  };
  const readText = (area, key) => {
    try { return window[area].getItem(prefix + key) || ''; } catch { return ''; }
  };
  const write = (area, key, value) => {
    try { window[area].setItem(prefix + key, String(value)); } catch {}
  };
  const remove = (area, key) => {
    try { window[area].removeItem(prefix + key); } catch {}
  };
  const journeyLifetime = 30 * 60 * 1000;
  const recent = timestamp => timestamp > 0 && Date.now() - timestamp >= 0 && Date.now() - timestamp < journeyLifetime;
  let emailDraft = null;
  try {
    const saved = JSON.parse(sessionStorage.getItem(prefix + 'email-draft'));
    if (saved && recent(saved.at) && typeof saved.value === 'string') emailDraft = saved.value;
    else remove('sessionStorage', 'email-draft');
  } catch { remove('sessionStorage', 'email-draft'); }
  const clearJourney = () => remove('sessionStorage', 'email-draft');
  const suppress = days => {
    const until = Date.now() + days * day;
    write('localStorage', 'until', until);
    write('sessionStorage', 'until', until);
  };
  const suppressed = () => Math.max(read('localStorage', 'until'), read('sessionStorage', 'until')) > Date.now();
  const dismissDays = 14;
  const markSubscribed = () => { suppress(365); write('localStorage', 'state', 'subscribed'); };
  const safeURL = value => {
    if (typeof value !== 'string' || !value.trim()) return null;
    try {
      const url = new URL(value, location.href);
      return url.origin === location.origin && !url.username && !url.password && /^https?:$/.test(url.protocol) ? url : null;
    } catch { return null; }
  };
  const relativeURL = url => url.pathname + url.search + url.hash;
  const productPath = url => /\/products\/[^/]+\/?$/.test(url.pathname);
  const productForm = () => document.querySelector('.cx-product-form');
  const contextKey = prefix + 'context';
  let context = null;
  try {
    const stored = JSON.parse(sessionStorage.getItem(contextKey));
    const url = stored && safeURL(stored.url);
    if (url && Date.now() - stored.at >= 0 && Date.now() - stored.at < 30 * 60 * 1000 && (productPath(url) || url.pathname === location.pathname)) context = { ...stored, url: relativeURL(url) };
  } catch {}
  const captureContext = () => {
    const url = safeURL(location.href);
    if (!url) return;
    const purchase = popup.dataset.productPage === 'true' ? productForm() : null;
    const variant = purchase?.querySelector('[name="id"]')?.value || '';
    const plans = purchase?.querySelectorAll('[name="selling_plan"]');
    const plan = purchase?.querySelector('[name="selling_plan"]:checked, input[type="hidden"][name="selling_plan"], select[name="selling_plan"]')?.value || '';
    if (/^\d+$/.test(variant)) url.searchParams.set('variant', variant);
    if (plans?.length) {
      if (/^\d+$/.test(plan)) url.searchParams.set('selling_plan', plan);
      else url.searchParams.delete('selling_plan');
    }
    url.searchParams.delete('customer_posted');
    if (url.hash === '#' + form.id) url.hash = '';
    context = { url: relativeURL(url), at: Date.now(), experience: popup.dataset.experience, variant, plan, quantity: purchase?.querySelector('[name="quantity"]')?.value || '', scroll: window.scrollY };
    try { sessionStorage.setItem(contextKey, JSON.stringify(context)); } catch {}
  };
  // Goal picker data comes from snippets/cx-goal-data.liquid. Without it the popup falls back to the plain email step.
  let goalData = null;
  try { goalData = JSON.parse(popup.querySelector('[data-cx-goal-data]')?.textContent || 'null'); } catch { goalData = null; }
  const goalProducts = goalData?.products || {};
  const goalCopy = goalData?.copy || {};
  const goalMode = popup.dataset.experience === 'goal' && Object.keys(goalProducts).length > 0 && Boolean(goalCopy.q_goal);
  const pageGoal = goalProducts[popup.dataset.productHandle] ? popup.dataset.productHandle : '';
  const storedGoal = readText('localStorage', 'goal');
  let goal = pageGoal || (goalProducts[storedGoal] ? storedGoal : '');
  const tagsFor = () => {
    const tags = ['newsletter', 'popup'];
    if (trigger && trigger !== 'resume') tags.push('popup-' + trigger);
    if (goalMode) tags.push('popup-goal');
    if (goal && goal !== 'menopause' && goalProducts[goal]) tags.push('interest-' + goal);
    return tags.join(',');
  };
  const pending = read('sessionStorage', 'pending');
  const freshPending = recent(pending);
  const nativeAnchor = location.hash === '#' + form.id && new URL(form.action, location.href).hash === '#' + form.id;
  const ownResult = Boolean(result && (freshPending || nativeAnchor));
  document.addEventListener('submit', event => {
    if (event.target === form) {
      const tags = form.querySelector('input[name="contact[tags]"]');
      if (tags) tags.value = tagsFor();
      captureContext();
      write('sessionStorage', 'pending', Date.now());
    } else if (event.target.querySelector?.('input[name="form_type"][value="customer"]')) {
      remove('sessionStorage', 'pending');
      clearJourney();
      try { sessionStorage.removeItem(contextKey); } catch {}
    }
  }, true);
  if (pending && !ownResult && Date.now() - pending >= 30 * 60 * 1000) remove('sessionStorage', 'pending');
  if (result && !ownResult) {
    if (result === 'success') { markSubscribed(); clearJourney(); }
    return;
  }
  if (popup.dataset.welcomeIneligible === 'true' || (!ownResult && popup.dataset.excluded === 'true')) return;
  // Visitors arriving from our own email or SMS are already subscribed.
  const params = new URLSearchParams(location.search);
  if (!ownResult && (params.has('_kx') || /^(email|sms)$/i.test(params.get('utm_medium') || '') || /klaviyo/i.test(params.get('utm_source') || ''))) {
    suppress(365);
    write('localStorage', 'state', 'subscriber');
  }
  const autoOpenBlocked = !ownResult && suppressed();
  if (ownResult) {
    remove('sessionStorage', 'pending');
    if (result === 'success') { markSubscribed(); clearJourney(); }
  }
  const returnLink = popup.querySelector('[data-cx-popup-return]');
  const returnURL = safeURL(context?.url || location.href);
  const samePage = returnURL?.pathname === location.pathname && (!context?.variant || productForm()?.querySelector('[name="id"]')?.value === context.variant);
  if (ownResult && result === 'success') {
    const dismiss = popup.querySelector('[data-success-label]');
    if (dismiss) dismiss.textContent = dismiss.dataset.successLabel;
  }
  if (ownResult && context && samePage) {
    const purchase = productForm();
    const variant = purchase?.querySelector('[name="id"]');
    if (variant && variant.value === context.variant) {
      const plan = [...purchase.querySelectorAll('input[name="selling_plan"]')].find(input => input.value === context.plan);
      if (plan?.type === 'radio' && !plan.disabled) plan.checked = true;
      const quantity = purchase.querySelector('[name="quantity"]');
      if (quantity && /^\d+$/.test(context.quantity) && Number(context.quantity) >= Number(quantity.min || 1) && (!quantity.max || Number(context.quantity) <= Number(quantity.max))) {
        quantity.value = context.quantity;
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      }
      purchase.dispatchEvent(new CustomEvent('cx:purchase-updated', { bubbles: true }));
    }
  }
  if (returnLink && returnURL) {
    returnURL.searchParams.delete('customer_posted');
    if (returnURL.hash === '#' + form.id) returnURL.hash = '';
    const goalProduct = goalMode && goal && !productPath(returnURL) ? goalProducts[goal] : null;
    const goalURL = goalProduct ? safeURL(goalProduct.url) : null;
    if (goalURL && goalCopy.shop) {
      returnLink.href = relativeURL(goalURL);
      returnLink.textContent = goalCopy.shop.replace('__product__', goalProduct.title);
    } else {
      returnLink.href = relativeURL(returnURL);
      returnLink.textContent = productPath(returnURL) ? returnLink.dataset.productLabel : returnLink.dataset.browseLabel;
      returnLink.addEventListener('click', event => {
        if (!samePage || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
        event.preventDefault();
        popup.close();
      });
    }
  }
  const copyButton = popup.querySelector('[data-cx-popup-copy]');
  copyButton?.addEventListener('click', async () => {
    if (copyButton.disabled) return;
    const code = popup.querySelector('[data-cx-popup-code]');
    const status = popup.querySelector('[data-cx-popup-copy-status]');
    copyButton.disabled = true;
    try {
      if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(code.textContent.trim());
      status.textContent = copyButton.dataset.copied;
    } catch {
      code.focus();
      const range = document.createRange();
      range.selectNodeContents(code);
      const selection = window.getSelection();
      selection?.removeAllRanges();
      selection?.addRange(range);
      status.textContent = copyButton.dataset.copyFailed;
    } finally { copyButton.disabled = false; }
  });
  const email = popup.querySelector('#cx-popup-email');
  if (email && !email.value && emailDraft && ownResult && result === 'error') email.value = emailDraft;
  const rememberEmail = () => {
    if (!email) return;
    try { sessionStorage.setItem(prefix + 'email-draft', JSON.stringify({ at: Date.now(), value: email.value })); } catch {}
  };
  email?.addEventListener('input', rememberEmail);
  email?.addEventListener('change', rememberEmail);
  const signal = step => document.dispatchEvent(new CustomEvent('cx:welcome', { detail: { experience: popup.dataset.experience, step, trigger } }));
  form.addEventListener('submit', () => { rememberEmail(); signal('submit'); });
  // Views: ask (pick a goal), match (patch named, email step), plain (email step only), success (the code).
  // Icons are fixed strings from this file, never page or visitor data.
  const ICONS = {
    moon: '<path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z"/>',
    sun: '<circle cx="12" cy="12" r="4"/><path d="M12 2.5v2.5M12 19v2.5M2.5 12H5M19 12h2.5M5.3 5.3l1.8 1.8M16.9 16.9l1.8 1.8M5.3 18.7l1.8-1.8M16.9 7.1l1.8-1.8"/>',
    horizon: '<path d="M3 18.5h18"/><path d="M4.5 18.5l5-8.5 3.5 5.5 2.5-3.5 4 6.5"/>',
    scale: '<path d="M12 4.5v15"/><path d="M7.5 19.5h9"/><path d="M5 8h14"/><path d="M5 8l-2.3 5.5a2.5 2.5 0 0 0 4.6 0z"/><path d="M19 8l-2.3 5.5a2.5 2.5 0 0 0 4.6 0z"/>',
    person: '<circle cx="12" cy="8" r="3.5"/><path d="M5 20a7 7 0 0 1 14 0"/>',
    drop: '<path d="M12 3.5s6 6.2 6 10.5a6 6 0 0 1-12 0c0-4.3 6-10.5 6-10.5z"/>',
    next: '<path d="M9 5l7 7-7 7"/>'
  };
  const icon = (name, size = 22) => {
    const holder = document.createElement('span');
    holder.style.display = 'flex';
    holder.innerHTML = '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (ICONS[name] || '') + '</svg>';
    return holder;
  };
  const goalIcon = { sleep: 'moon', energy: 'sun', longevity: 'horizon', menopause: 'scale', 'male-vitality': 'person', 'ghk-cu': 'drop', berberine: 'horizon' };
  const sized = (url, width) => (url || '').replace(/([?&]width=)\d+/, '$1' + width);
  const eyebrow = popup.querySelector('[data-cx-popup-eyebrow]');
  const intro = popup.querySelector('[data-cx-popup-intro]');
  const description = popup.querySelector('#cx-popup-description');
  const goalStage = popup.querySelector('[data-cx-goal-stage]');
  const signupStage = popup.querySelector('[data-cx-signup-stage]');
  const againButton = popup.querySelector('[data-cx-goal-again]');
  const match = popup.querySelector('[data-cx-popup-match]');
  const matchTitle = popup.querySelector('[data-cx-match-title]');
  const steps = popup.querySelector('[data-cx-popup-steps]');
  const shopStage = popup.querySelector('[data-cx-goal-shop-stage]');
  const shopLink = popup.querySelector('[data-cx-goal-shop]');
  const aside = popup.querySelector('.cx-email-popup__aside');
  const offerToggle = popup.querySelector('[data-cx-offer-toggle]');
  const terms = popup.querySelector('#cx-popup-terms');
  popup.dataset.view = result === 'success' ? 'success' : 'plain';
  const fillMatch = handle => {
    const product = goalProducts[handle];
    if (!match || !product) return;
    const matchEyebrow = match.querySelector('[data-cx-match-eyebrow]');
    const pill = match.querySelector('[data-cx-match-pill]');
    const photo = match.querySelector('[data-cx-match-photo]');
    match.style.background = product.tint || '';
    if (matchEyebrow) {
      matchEyebrow.textContent = pageGoal ? (eyebrow?.textContent || '') : (goalCopy.match || eyebrow?.textContent || '');
      matchEyebrow.style.color = product.ink || '';
    }
    if (matchTitle) {
      matchTitle.textContent = product.title + '.';
      if (handle !== 'berberine' && goalData?.titleTail) matchTitle.append(document.createElement('br'), document.createTextNode(goalData.titleTail));
    }
    if (pill) { pill.textContent = product.subline || ''; pill.hidden = !product.subline; }
    if (photo) {
      if (product.image) photo.src = sized(product.image, 240);
      photo.hidden = !product.image;
    }
  };
  const showGoalStep = () => {
    if (!goalMode || !goalStage || !signupStage || !match) return;
    const asking = !goal;
    const recommendationOnly = goal === 'berberine';
    goalStage.hidden = !asking;
    signupStage.hidden = asking || recommendationOnly;
    match.hidden = asking;
    if (intro) intro.hidden = !asking;
    if (description) description.hidden = asking || recommendationOnly;
    if (aside) aside.hidden = recommendationOnly;
    if (offerToggle) offerToggle.hidden = recommendationOnly;
    if (terms && recommendationOnly) {
      terms.hidden = true;
      offerToggle?.setAttribute('aria-expanded', 'false');
    }
    if (shopStage) shopStage.hidden = !recommendationOnly;
    if (shopLink && recommendationOnly) {
      const product = goalProducts[goal];
      const url = safeURL(product.url);
      shopLink.href = url ? relativeURL(url) : product.url;
      shopLink.textContent = (goalCopy.shop || '__product__').replace('__product__', product.title);
    }
    popup.setAttribute('aria-labelledby', asking ? 'cx-popup-title' : 'cx-popup-match-title');
    popup.setAttribute('aria-describedby', recommendationOnly ? 'cx-popup-berberine-note' : 'cx-popup-description');
    if (againButton) againButton.hidden = asking || Boolean(pageGoal);
    if (steps) {
      const step = asking ? 1 : 2;
      steps.hidden = recommendationOnly || Boolean(pageGoal) || !goalCopy.step;
      steps.querySelectorAll('[data-cx-popup-seg]').forEach((segment, index) => segment.classList.toggle('is-done', index < step));
      const stepLabel = steps.querySelector('[data-cx-popup-step-label]');
      if (stepLabel) stepLabel.textContent = (goalCopy.step || '').replace('__n__', String(step));
    }
    popup.dataset.view = asking ? 'ask' : (recommendationOnly ? 'recommendation' : 'match');
    if (!asking) fillMatch(goal);
  };
  if (goalMode && goalStage && result !== 'success') {
    const question = goalStage.querySelector('[data-cx-goal-question]');
    const options = goalStage.querySelector('[data-cx-goal-options]');
    const quizLink = goalStage.querySelector('[data-cx-goal-quiz]');
    if (question) question.textContent = goalCopy.q_goal;
    ['sleep', 'energy', 'longevity', 'menopause', 'male-vitality', 'ghk-cu', 'berberine'].forEach(handle => {
      const product = goalProducts[handle];
      const label = goalCopy['goal_' + handle.replace(/-/g, '_')];
      if (!product || !label || !options) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'cx-email-popup__goal-option';
      button.dataset.cxGoal = handle;
      const tile = document.createElement('span');
      tile.className = 'cx-email-popup__goal-icon';
      tile.append(icon(goalIcon[handle]));
      const words = document.createElement('span');
      words.className = 'cx-email-popup__goal-text';
      const name = document.createElement('strong');
      name.textContent = label;
      const hint = document.createElement('span');
      hint.className = 'cx-email-popup__goal-name';
      const dot = document.createElement('span');
      dot.className = 'cx-email-popup__goal-dot';
      dot.style.background = product.dot || '#8a947c';
      const productName = document.createElement('span');
      productName.textContent = product.name;
      hint.append(dot, productName);
      words.append(name, hint);
      const next = document.createElement('span');
      next.className = 'cx-email-popup__goal-next';
      next.append(icon('next', 18));
      button.append(tile, words, next);
      button.addEventListener('click', () => {
        goal = handle;
        write('localStorage', 'goal', handle);
        showGoalStep();
        signal('goal');
        (finePointer.matches && !signupStage.hidden ? email : matchTitle)?.focus({ preventScroll: true });
      });
      options.append(button);
    });
    if (quizLink && goalData?.quizUrl && goalCopy.quiz_link) {
      quizLink.href = goalData.quizUrl;
      quizLink.textContent = goalCopy.quiz_link;
      quizLink.hidden = false;
      quizLink.addEventListener('click', () => { if (popup.open) popup.close(); });
    }
    if (againButton) {
      againButton.textContent = goalCopy.choose_again || '';
      againButton.addEventListener('click', () => {
        goal = '';
        remove('localStorage', 'goal');
        showGoalStep();
        goalStage.querySelector('button')?.focus({ preventScroll: true });
      });
    }
    showGoalStep();
  }
  offerToggle?.addEventListener('click', () => {
    if (!terms) return;
    terms.hidden = !terms.hidden;
    offerToggle.setAttribute('aria-expanded', String(!terms.hidden));
    if (!terms.hidden) terms.scrollIntoView({ block: 'nearest' });
  });
  // Welcome triggers, first one wins: engaged time across the session, a deep scroll, or exit intent on desktop.
  // Articles open on scroll or exit only. After a dismissal the popup rests for 14 days and a small teaser keeps the offer reachable.
  const reading = popup.dataset.reading === 'true';
  const scrollShare = reading ? .6 : .5;
  const scrollFloor = Math.min(delay, 4000);
  const exitFloor = 3000;
  const quietGap = 800;
  const bannerPatience = Math.max(30000, delay);
  let engaged = Math.max(0, read('sessionStorage', 'engaged'));
  let visibleSince = document.visibilityState === 'visible' ? performance.now() : null;
  let lastGesture = -Infinity;
  let scrolledFar = false;
  let checkoutStarted = false;
  let finished = autoOpenBlocked;
  let timer = null;
  let returnFocus = null;
  const engagedNow = () => engaged + (visibleSince === null ? 0 : Math.max(0, performance.now() - visibleSince));
  const saveTime = () => {
    engaged = engagedNow();
    visibleSince = document.visibilityState === 'visible' ? performance.now() : null;
    write('sessionStorage', 'engaged', Math.round(engaged));
  };
  const stop = () => {
    if (timer !== null) clearInterval(timer);
    timer = null;
  };
  const consentPending = () => {
    const banner = document.getElementById('shopify-pc__banner');
    return Boolean(banner && banner.getClientRects().length && getComputedStyle(banner).visibility !== 'hidden');
  };
  const typing = element => Boolean(element && (element.tagName === 'IFRAME' || element.isContentEditable || element.matches('textarea,select,input:not([type="radio"],[type="checkbox"],[type="button"],[type="submit"],[type="reset"],[type="range"],[type="hidden"])')));
  const busy = () => {
    if (checkoutStarted) return true;
    if (document.querySelector('.cx-product-form[data-busy],[data-cx-cart-content][aria-busy="true"]')) return true;
    if (document.querySelector('dialog[open]:not(#cx-email-popup),.merge-shop[open],.cx-guided-menu[open],.cx-language[open],.cx-mobile-menu[open]')) return true;
    const otherModal = [...document.querySelectorAll('[aria-modal="true"]:not(#cx-email-popup)')].some(element => !element.closest('[hidden],[aria-hidden="true"]') && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden');
    return otherModal || typing(document.activeElement);
  };
  const teaser = document.querySelector('[data-cx-welcome-teaser]');
  const placeTeaser = () => {
    if (!teaser || teaser.hidden) return;
    let offset = 0;
    document.querySelectorAll('.cx-pdp__sticky').forEach(bar => {
      if (bar.hidden || !bar.getClientRects().length || getComputedStyle(bar).visibility === 'hidden') return;
      const box = bar.getBoundingClientRect();
      if (box.bottom >= window.innerHeight - 2 && box.top < window.innerHeight) offset = Math.max(offset, window.innerHeight - box.top);
    });
    teaser.style.setProperty('--cx-teaser-offset', Math.round(offset) + 'px');
  };
  const hideTeaser = () => { if (teaser) teaser.hidden = true; };
  const showTeaser = () => {
    if (!teaser || popup.open || readText('localStorage', 'state') !== 'dismissed') return;
    teaser.hidden = false;
    placeTeaser();
  };
  const show = reason => {
    if (popup.open || document.visibilityState !== 'visible') return false;
    const asked = reason === 'teaser' || reason === 'link';
    if (!asked && busy()) return false;
    if (!ownResult && !asked && suppressed()) { finished = true; stop(); showTeaser(); return false; }
    trigger = reason;
    returnFocus = document.activeElement;
    hideTeaser();
    popup.showModal();
    signal('open');
    if (ownResult) signal(result);
    const formError = popup.querySelector('#cx-popup-errors');
    if (formError) formError.focus();
    else [popup.querySelector('#cx-popup-title'), popup.querySelector('[data-cx-goal-question]'), matchTitle].find(element => element && element.getClientRects().length > 0)?.focus({preventScroll: true});
    finished = true;
    stop();
    return true;
  };
  const dueReason = () => {
    const time = engagedNow();
    if (!reading && time >= delay) return 'time';
    if (scrolledFar && time >= scrollFloor) return 'scroll';
    return '';
  };
  const tick = () => {
    if (finished) return;
    saveTime();
    if (ownResult) { show('resume'); return; }
    if (suppressed()) { finished = true; stop(); showTeaser(); return; }
    const reason = dueReason();
    if (!reason || performance.now() - lastGesture < quietGap) return;
    if (consentPending() && engagedNow() < bannerPatience) return;
    show(reason);
  };
  const start = () => {
    if (finished || timer !== null || document.visibilityState !== 'visible') return;
    engaged = Math.max(engaged, read('sessionStorage', 'engaged'));
    visibleSince = performance.now();
    timer = setInterval(tick, 500);
    tick();
  };
  const noteGesture = event => {
    if (finished || popup.open || !event.isTrusted) return;
    lastGesture = performance.now();
    if (event.type === 'click' && event.target.closest?.('[name="checkout"],a[href*="/checkout"],[data-shopify="payment-button"]')) checkoutStarted = true;
  };
  ['pointerdown','pointerup','keydown','wheel','click','touchmove'].forEach(type => document.addEventListener(type, noteGesture, {passive: true, capture: true}));
  window.addEventListener('scroll', () => {
    if (finished || popup.open) return;
    lastGesture = performance.now();
    const scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollable > 0 && window.scrollY / scrollable >= scrollShare) scrolledFar = true;
  }, {passive: true});
  document.addEventListener('mouseout', event => {
    if (finished || popup.open || event.relatedTarget || event.clientY > 8 || !finePointer.matches) return;
    if (engagedNow() >= exitFloor) show('exit');
  });
  teaser?.addEventListener('click', () => show('teaser'));
  let placeFrame = null;
  const schedulePlace = () => {
    if (placeFrame === null) placeFrame = requestAnimationFrame(() => { placeFrame = null; placeTeaser(); });
  };
  window.addEventListener('scroll', schedulePlace, {passive: true});
  window.addEventListener('resize', schedulePlace);
  if ('MutationObserver' in window) {
    const barWatch = new MutationObserver(schedulePlace);
    document.querySelectorAll('.cx-pdp__sticky').forEach(bar => barWatch.observe(bar, {attributes: true, attributeFilter: ['hidden', 'class', 'style']}));
  }
  window.cxWelcome = {
    open: (reason = 'link') => show(reason === 'teaser' ? 'teaser' : 'link'),
    suppress: (days = 365) => { suppress(Number(days) || 365); write('localStorage', 'state', 'suppressed'); hideTeaser(); finished = true; stop(); }
  };
  document.addEventListener('cx:welcome-suppress', event => window.cxWelcome.suppress(event.detail?.days));
  const focusPage = () => {
    const target = document.querySelector('main h1,main h2,main a,main button');
    if (!target) return;
    if (!target.matches('a,button,input,select,textarea,[tabindex]')) target.tabIndex = -1;
    target.focus({ preventScroll: true });
  };
  popup.addEventListener('close', () => {
    signal('close');
    clearJourney();
    remove('sessionStorage', 'pending');
    if (result === 'success' && ownResult) markSubscribed();
    else {
      suppress(dismissDays);
      write('localStorage', 'state', 'dismissed');
      showTeaser();
    }
    if (ownResult && samePage && Number.isFinite(context?.scroll)) window.scrollTo({ top: Math.max(0, context.scroll), behavior: 'instant' });
    if (returnFocus?.isConnected && returnFocus !== document.body && !returnFocus.closest('[hidden]')) returnFocus.focus({preventScroll: true});
    else if (ownResult && samePage && productForm()) productForm()?.querySelector('[type="submit"]')?.focus({ preventScroll: true });
    else focusPage();
  });
  popup.querySelectorAll('[data-cx-popup-close]').forEach(button => button.addEventListener('click', () => popup.close()));
  let backdropPointerDown = false;
  const outside = event => {
    const bounds = popup.getBoundingClientRect();
    return event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
  };
  popup.addEventListener('pointerdown', event => { backdropPointerDown = event.target === popup && outside(event); });
  popup.addEventListener('click', event => {
    if (backdropPointerDown && event.target === popup && outside(event)) popup.close();
    backdropPointerDown = false;
  });
  document.addEventListener('visibilitychange', () => {
    saveTime();
    if (document.visibilityState === 'visible') start();
    else { visibleSince = null; stop(); }
  });
  window.addEventListener('pagehide', () => { saveTime(); visibleSince = null; stop(); });
  window.addEventListener('pageshow', event => { if (event.persisted) start(); });
  if (autoOpenBlocked) showTeaser();
  start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cx-guided-product-nav"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = nav => {
    if (nav.dataset.guidedNavReady) return;
    nav.dataset.guidedNavReady = 'true';
    const root = nav.closest('.cx-pdp');
    const controller = new AbortController();
    const { signal } = controller;
    const links = Array.from(nav.querySelectorAll('.cx-guided-product-nav__links a'));
    const entries = links.map(link => ({ link, target: document.getElementById(link.hash.slice(1)) })).filter(entry => entry.target);
    let frame = 0;
    let settleTimer = 0;
    let selected = null;
    let destroyed = false;
    const clearance = () => (parseFloat(getComputedStyle(nav).top) || 0) + nav.getBoundingClientRect().height + 20;
    const activate = id => links.forEach(link => {
      if (link.hash === '#' + id) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
    const update = () => {
      frame = 0;
      if (destroyed || selected || !entries.length) return;
      const ordered = entries.map(entry => ({ ...entry, top: entry.target.getBoundingClientRect().top })).sort((a, b) => a.top - b.top);
      const passed = ordered.filter(entry => entry.top <= clearance() + 2);
      activate((passed[passed.length - 1] || ordered[0]).target.id);
    };
    const schedule = () => {
      if (!frame && !destroyed) frame = requestAnimationFrame(update);
    };
    const release = () => {
      clearTimeout(settleTimer);
      selected = null;
      schedule();
    };
    const onScroll = () => {
      if (selected) {
        clearTimeout(settleTimer);
        settleTimer = setTimeout(release, 160);
      }
      schedule();
    };
    const measure = () => {
      root?.style.setProperty('--cx-product-nav-height', nav.getBoundingClientRect().height + 'px');
      schedule();
    };
    const navigate = (target, smooth, focus) => {
      let disclosure = target.closest('details');
      while (disclosure) {
        disclosure.open = true;
        disclosure = disclosure.parentElement?.closest('details');
      }
      selected = target;
      activate(target.id);
      clearTimeout(settleTimer);
      if (focus) {
        if (!target.hasAttribute('tabindex')) {
          target.setAttribute('tabindex', '-1');
          target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true, signal });
        }
        target.focus({ preventScroll: true });
      }
      window.scrollTo({
        top: Math.max(0, window.scrollY + target.getBoundingClientRect().top - clearance()),
        behavior: smooth && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant'
      });
      settleTimer = setTimeout(release, 1200);
    };
    (root || nav).addEventListener('click', event => {
      const link = event.target.closest('a');
      if (!link || (!nav.contains(link) && !link.matches('a.cx-pdp__description-link')) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const target = document.getElementById(link.hash.slice(1));
      if (!target) return;
      event.preventDefault();
      if (window.location.hash !== link.hash) window.history.pushState(null, '', link.hash);
      navigate(target, true, true);
    }, { signal });
    const fromHash = () => {
      const link = Array.from(nav.querySelectorAll('a')).find(item => item.hash === window.location.hash);
      const purchaseTarget = root?.querySelector('.cx-pdp__plans');
      const target = link ? document.getElementById(link.hash.slice(1)) : purchaseTarget && window.location.hash === '#' + purchaseTarget.id ? purchaseTarget : null;
      if (target) navigate(target, false, false);
      else release();
    };
    window.addEventListener('scroll', onScroll, { passive: true, signal });
    window.addEventListener('scrollend', release, { signal });
    window.addEventListener('resize', measure, { passive: true, signal });
    window.addEventListener('hashchange', fromHash, { signal });
    window.addEventListener('wheel', release, { passive: true, signal });
    window.addEventListener('touchstart', release, { passive: true, signal });
    window.addEventListener('keydown', event => {
      if (['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End', ' '].includes(event.key)) release();
    }, { signal });
    const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(measure) : null;
    if (observer) {
      observer.observe(nav);
      if (root) observer.observe(root);
    }
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(nav)) return;
      destroyed = true;
      controller.abort();
      observer?.disconnect();
      cancelAnimationFrame(frame);
      clearTimeout(settleTimer);
      delete nav.dataset.guidedNavReady;
    }, { signal });
    measure();
    if (window.location.hash) {
      if (document.readyState === 'complete') fromHash();
      else window.addEventListener('load', fromHash, { once: true, signal });
    }
  };
  document.querySelectorAll('[data-cx-guided-product-nav]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-cx-guided-product-nav]').forEach(init));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cx-header"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    const header = document.querySelector('[data-cx-guided-header]');
    if (!header || header.dataset.guidedReady) return;
    header.dataset.guidedReady = 'true';
    const menus = Array.from(header.querySelectorAll('[data-cx-guided-menu]'));
    const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
    const compactQuery = window.matchMedia('(max-width:760px), (max-width:1024px) and (max-height:500px)');
    const closeTimers = new Map();
    const cancelClose = menu => {
      if (!closeTimers.has(menu)) return;
      clearTimeout(closeTimers.get(menu));
      closeTimers.delete(menu);
    };
    const close = (menu, restoreFocus = false) => {
      cancelClose(menu);
      if (!menu.open) return;
      menu.open = false;
      if (restoreFocus) menu.querySelector('summary')?.focus();
    };
    const closeAll = exception => menus.forEach(menu => { if (menu !== exception) close(menu); });
    let heightFrame = 0;
    let heightObserver = null;
    let heightDisposed = false;
    const applyHeight = height => {
      if (heightDisposed || !Number.isFinite(height) || height <= 0) return;
      const value = `${Math.ceil(height)}px`;
      const style = document.documentElement.style;
      if (style.getPropertyValue('--cx-header-height') !== value) style.setProperty('--cx-header-height', value);
    };
    const scheduleHeight = () => {
      if (heightDisposed || heightFrame) return;
      heightFrame = requestAnimationFrame(() => {
        heightFrame = 0;
        if (!heightDisposed) applyHeight(header.getBoundingClientRect().height);
      });
    };
    const layoutChanged = () => { if (!heightObserver) scheduleHeight(); };
    menus.forEach(menu => {
      const summary = menu.querySelector('summary');
      const button = menu.querySelector('[data-cx-guided-close]');
      const panel = menu.querySelector('.cx-guided-panel');
      summary.addEventListener('click', () => {
        cancelClose(menu);
        if (!menu.open) {
          closeAll(menu);
          header.querySelector('[data-cx-language]')?.removeAttribute('open');
        }
      });
      const enter = event => {
        if (compactQuery.matches || !hoverQuery.matches || event.pointerType !== 'mouse') return;
        cancelClose(menu);
        closeAll(menu);
        header.querySelector('[data-cx-language]')?.removeAttribute('open');
        menu.open = true;
      };
      const leave = event => {
        if (compactQuery.matches || !hoverQuery.matches || event.pointerType !== 'mouse') return;
        cancelClose(menu);
        closeTimers.set(menu, setTimeout(() => {
          closeTimers.delete(menu);
          if (!menu.contains(document.activeElement)) close(menu);
        }, 180));
      };
      menu.addEventListener('pointerenter', enter);
      menu.addEventListener('pointerleave', leave);
      panel?.addEventListener('pointerenter', enter);
      panel?.addEventListener('pointerleave', leave);
      menu.addEventListener('toggle', () => summary.setAttribute('aria-expanded', String(menu.open)));
      summary.setAttribute('aria-expanded', String(menu.open));
      if (button) { button.hidden = false; button.addEventListener('click', () => close(menu, true)); }
      menu.addEventListener('focusout', () => {
        setTimeout(() => { if (menu.open && !menu.contains(document.activeElement)) close(menu); }, 0);
      });
    });
    document.addEventListener('click', event => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const owner = target.closest('[data-cx-guided-menu]');
      closeAll(owner);
      if (target.closest('[data-cx-cart-open]') || target.closest('.cx-guided-panel a')) closeAll();
    });
    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      if (header.querySelector('[data-cx-mobile-navigation][open]')) return;
      const openMenu = menus.find(menu => menu.open);
      if (openMenu) { close(openMenu, true); event.preventDefault(); }
    });
    hoverQuery.addEventListener('change', () => menus.forEach(cancelClose));
    if (typeof ResizeObserver === 'function') {
      heightObserver = new ResizeObserver(entries => {
        if (heightDisposed) return;
        const entry = entries.find(item => item.target === header);
        const box = entry?.borderBoxSize?.[0] || entry?.borderBoxSize;
        if (Number.isFinite(box?.blockSize)) applyHeight(box.blockSize);
        else scheduleHeight();
      });
      heightObserver.observe(header, {box:'border-box'});
    } else {
      window.addEventListener('resize', scheduleHeight, {passive:true});
      document.fonts?.ready.then(scheduleHeight);
      scheduleHeight();
    }
    document.addEventListener('cx:header-layout', layoutChanged);
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(header)) return;
      heightDisposed = true;
      heightObserver?.disconnect();
      cancelAnimationFrame(heightFrame);
      window.removeEventListener('resize', scheduleHeight);
      document.removeEventListener('cx:header-layout', layoutChanged);
    });
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cx-ingredient-guide"] && !Shopify.designMode) return;
  try {
    (() => {
  const revealIngredient = () => {
    if (!location.hash.startsWith('#CxIngredient-')) return;
    const target = document.getElementById(location.hash.slice(1));
    if (target?.matches('details.cx-ingredient-guide__item')) target.open = true;
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('.cx-ingredient-guide__index a');
    if (!link) return;
    const target = document.getElementById(link.hash.slice(1));
    if (target?.matches('details.cx-ingredient-guide__item')) target.open = true;
  });
  window.addEventListener('hashchange', revealIngredient);
  document.addEventListener('shopify:section:load', revealIngredient);
  revealIngredient();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cx-mobile-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    const header = document.querySelector('[data-cx-guided-header]');
    if (!header || header.dataset.mobileReady) return;
    const toggle = header.querySelector('[data-cx-mobile-toggle]');
    const drawer = header.querySelector('[data-cx-mobile-navigation]');
    const home = header.querySelector('[data-cx-navigation-home]');
    const nav = home?.querySelector('.cx-guided-nav');
    const content = drawer?.querySelector('[data-cx-mobile-content]');
    const closeButton = drawer?.querySelector('[data-cx-mobile-close]');
    if (!toggle || !nav || !content || !closeButton || typeof drawer.showModal !== 'function') return;
    header.dataset.mobileReady = 'true';
    const compact = window.matchMedia('(max-width:760px), (max-width:1024px) and (max-height:500px)');
    let restoreFocus = true;
    let backdropPointer = false;
    const closeMenus = () => nav.querySelectorAll('details[open]').forEach(menu => { menu.open = false; });
    const close = (restore = true) => {
      restoreFocus = restore;
      if (drawer.open) drawer.close();
    };
    const sync = () => {
      close(false);
      closeMenus();
      const destination = compact.matches ? content : home;
      if (nav.parentElement !== destination) destination.append(nav);
      toggle.hidden = !compact.matches;
      toggle.setAttribute('aria-expanded', 'false');
      document.dispatchEvent(new CustomEvent('cx:header-layout'));
    };
    toggle.addEventListener('click', () => {
      if (!compact.matches) return;
      if (drawer.open) { close(); return; }
      closeMenus();
      header.querySelector('[data-cx-language]')?.removeAttribute('open');
      restoreFocus = true;
      drawer.showModal();
      toggle.setAttribute('aria-expanded', 'true');
      closeButton.focus({ preventScroll: true });
    });
    closeButton.addEventListener('click', () => close());
    drawer.addEventListener('cancel', event => { event.preventDefault(); close(); });
    drawer.addEventListener('close', () => {
      closeMenus();
      toggle.setAttribute('aria-expanded', 'false');
      if (restoreFocus && compact.matches) toggle.focus({ preventScroll: true });
    });
    const outside = event => {
      const rect = drawer.getBoundingClientRect();
      return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
    };
    drawer.addEventListener('pointerdown', event => { backdropPointer = event.target === drawer && outside(event); });
    drawer.addEventListener('click', event => {
      if (backdropPointer && event.target === drawer && outside(event)) close();
      backdropPointer = false;
      if (event.target instanceof Element && event.target.closest('a[href]')) close(false);
    });
    compact.addEventListener('change', sync);
    sync();
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cx-patch-quiz"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.querySelector('[data-cx-quiz]');
  if (!root || root.dataset.ready === 'true') return;
  let data = null;
  try { data = JSON.parse(root.querySelector('[data-cx-quiz-data]')?.textContent || 'null'); } catch { data = null; }
  const copy = data?.copy;
  const products = data?.products || {};
  const goals = ['sleep', 'energy', 'longevity', 'menopause', 'male-vitality', 'ghk-cu', 'berberine'].filter(handle => products[handle] && copy?.['goal_' + handle.replace(/-/g, '_')]);
  if (!copy || !goals.length) return;
  root.dataset.ready = 'true';
  const card = root.querySelector('[data-cx-quiz-card]');
  const stage = root.querySelector('[data-cx-quiz-stage]');
  const signup = root.querySelector('[data-cx-quiz-signup]');
  const form = root.querySelector('#cx-quiz-form');
  if (!card || !stage || !signup || !form) return;
  root.hidden = false;
  const result = root.querySelector('[data-cx-quiz-result]')?.dataset.cxQuizResult || '';
  const quizPrefix = 'cx-quiz-v1:';
  // Shared with snippets/cx-email-popup.liquid: the popup reads these keys to rest itself and to skip its goal question.
  const popupPrefix = 'cx-email-popup-v1:';
  const lifetime = 30 * 60 * 1000;
  const get = (area, key) => { try { return window[area].getItem(key); } catch { return null; } };
  const set = (area, key, value) => { try { window[area].setItem(key, String(value)); } catch {} };
  const del = (area, key) => { try { window[area].removeItem(key); } catch {} };
  const pendingAt = Number(get('sessionStorage', quizPrefix + 'pending')) || 0;
  const ownResult = Boolean(result) && ((pendingAt > 0 && Date.now() - pendingAt >= 0 && Date.now() - pendingAt < lifetime) || location.hash === '#cx-quiz-form');
  if (pendingAt) del('sessionStorage', quizPrefix + 'pending');
  let answers = {};
  try {
    const saved = JSON.parse(get('sessionStorage', quizPrefix + 'answers') || 'null');
    if (saved && Date.now() - saved.at >= 0 && Date.now() - saved.at < lifetime && saved.answers && typeof saved.answers === 'object') answers = saved.answers;
  } catch {}
  const save = () => set('sessionStorage', quizPrefix + 'answers', JSON.stringify({ at: Date.now(), answers }));
  // Signed in and subscribed, signed up on this browser before, or arrived from one of our emails.
  const knownSubscriber = () => {
    const state = get('localStorage', popupPrefix + 'state') || '';
    return root.dataset.subscriber === 'true' || state === 'subscribed' || state === 'subscriber';
  };
  let cartConfig = null;
  try { cartConfig = JSON.parse(document.getElementById('cx-config')?.textContent || 'null'); } catch { cartConfig = null; }
  const text = (key, product) => (copy[key] || '').replace('__product__', product || '');
  // Icons are fixed strings from this file, never page or visitor data.
  const ICONS = {
    back: '<path d="M15 5l-7 7 7 7"/>',
    arrow: '<path d="M5 12h14"/><path d="M13 6l6 6-6 6"/>',
    check: '<path d="M5 12.5l4.5 4.5L19 7.5"/>',
    sun: '<circle cx="12" cy="12" r="4"/><path d="M12 2.5v2.5M12 19v2.5M2.5 12H5M19 12h2.5M5.3 5.3l1.8 1.8M16.9 16.9l1.8 1.8M5.3 18.7l1.8-1.8M16.9 7.1l1.8-1.8"/>',
    moon: '<path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z"/>',
    clock: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
    help: '<circle cx="12" cy="12" r="9"/><path d="M9.5 9.5a2.5 2.5 0 1 1 3.6 2.2c-.7.4-1.1.9-1.1 1.8"/><path d="M12 17h.01"/>',
    horizon: '<path d="M3 18.5h18"/><path d="M4.5 18.5l5-8.5 3.5 5.5 2.5-3.5 4 6.5"/>',
    scale: '<path d="M12 4.5v15"/><path d="M7.5 19.5h9"/><path d="M5 8h14"/><path d="M5 8l-2.3 5.5a2.5 2.5 0 0 0 4.6 0z"/><path d="M19 8l-2.3 5.5a2.5 2.5 0 0 0 4.6 0z"/>',
    person: '<circle cx="12" cy="8" r="3.5"/><path d="M5 20a7 7 0 0 1 14 0"/>',
    drop: '<path d="M12 3.5s6 6.2 6 10.5a6 6 0 0 1-12 0c0-4.3 6-10.5 6-10.5z"/>',
    capsule: '<rect x="3.5" y="8.5" width="17" height="7" rx="3.5" transform="rotate(-45 12 12)"/><path d="M9.5 9.5l5 5"/>',
    glass: '<path d="M7 4h10l-1.2 15a1.5 1.5 0 0 1-1.5 1.4H9.7a1.5 1.5 0 0 1-1.5-1.4z"/><path d="M7.5 10h9"/>',
    patch: '<rect x="5" y="5" width="14" height="14" rx="4"/><path d="M9.5 12h5"/>',
    blank: '<circle cx="12" cy="12" r="8.5" stroke-dasharray="3 3.2"/>',
    pouch: '<path d="M7.5 4h9v3l1.5 2v9.5A1.5 1.5 0 0 1 16.5 20h-9A1.5 1.5 0 0 1 6 18.5V9l1.5-2z"/><path d="M7.5 7h9"/>',
    pair: '<rect x="3.5" y="3.5" width="11" height="11" rx="3"/><rect x="9.5" y="9.5" width="11" height="11" rx="3"/>',
    tag: '<path d="M4.5 12.5l8-8h7v7l-8 8z"/><circle cx="15.5" cy="8.5" r="1.2"/>'
  };
  const icon = (name, size = 22, width = 1.6) => {
    const holder = document.createElement('span');
    holder.style.display = 'flex';
    holder.innerHTML = '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="' + width + '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (ICONS[name] || '') + '</svg>';
    return holder;
  };
  const goalIcon = { sleep: 'moon', energy: 'sun', longevity: 'horizon', menopause: 'scale', 'male-vitality': 'person', 'ghk-cu': 'drop', berberine: 'horizon' };
  const option = (value, label, iconName, hint) => ({ value, label, icon: iconName, hint });
  const questions = [
    { key: 'goal', title: copy.q_goal, goal: true, options: goals.map(handle => option(handle, copy['goal_' + handle.replace(/-/g, '_')], goalIcon[handle], products[handle].name)) },
    { key: 'when', title: copy.q_when, options: [['morning', 'sun'], ['evening', 'moon'], ['allday', 'clock'], ['unsure', 'help']].map(([value, name]) => option(value, copy['when_' + value], name)) },
    { key: 'tried', title: copy.q_tried, options: [['capsules', 'capsule'], ['powders', 'glass'], ['patches', 'patch'], ['nothing', 'blank']].map(([value, name]) => option(value, copy['tried_' + value], name)) },
    { key: 'start', title: copy.q_start, options: [['pouch', 'pouch'], ['routine', 'pair'], ['try', 'tag']].map(([value, name]) => option(value, copy['start_' + value], name)) }
  ];
  const complete = () => questions.every(question => question.options.some(item => item.value === answers[question.key]));
  const el = (tag, props = {}, children = []) => {
    const node = document.createElement(tag);
    Object.entries(props).forEach(([name, value]) => {
      if (value === undefined || value === null || value === false) return;
      if (name === 'text') node.textContent = value;
      else if (name === 'className') node.className = value;
      else if (name === 'style') Object.assign(node.style, value);
      else if (name.startsWith('on')) node.addEventListener(name.slice(2), value);
      else node.setAttribute(name, value === true ? '' : value);
    });
    children.filter(Boolean).forEach(child => node.append(child));
    return node;
  };
  const sized = (url, width) => (url || '').replace(/([?&]width=)\d+/, '$1' + width);
  const signal = step => document.dispatchEvent(new CustomEvent('cx:quiz', { detail: { step } }));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const bringIntoView = () => {
    const box = root.getBoundingClientRect();
    if (box.top < 0 || box.top > window.innerHeight * .6) root.scrollIntoView({ block: 'start', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
  };
  const focusStage = () => {
    bringIntoView();
    stage.querySelector('[data-cx-quiz-focus]')?.focus({ preventScroll: true });
  };
  const intro = () => {
    card.dataset.view = 'intro';
    signup.hidden = true;
    stage.replaceChildren(el('div', { className: 'cx-quiz__pad' }, [
      el('div', { className: 'cx-quiz__thumbs', 'aria-hidden': 'true' }, goals.filter(handle => products[handle].image).map(handle => el('img', { src: sized(products[handle].image, 120), alt: '', width: '46', height: '46', loading: 'lazy', decoding: 'async' }))),
      el('p', { className: 'cx-quiz__eyebrow', text: copy.intro_eyebrow }),
      el('h2', { className: 'cx-quiz__title', text: copy.intro_title }),
      el('p', { className: 'cx-quiz__lead', text: copy.intro_body }),
      el('button', { type: 'button', className: 'cx-quiz__primary', 'data-cx-quiz-start': true, onclick: () => { signal('start'); ask(0); } }, [el('span', { text: copy.start }), icon('arrow', 18)]),
      copy.intro_note ? el('p', { className: 'cx-quiz__note', text: copy.intro_note }) : null
    ]));
  };
  const ask = index => {
    const question = questions[index];
    const headingId = 'cx-quiz-question-' + (index + 1);
    const label = (copy.progress || '').replace('__n__', String(index + 1)).replace('__total__', String(questions.length));
    card.dataset.view = 'question';
    signup.hidden = true;
    stage.replaceChildren(el('div', { className: 'cx-quiz__pad' }, [
      el('div', { className: 'cx-quiz__head' }, [
        el('button', { type: 'button', className: 'cx-quiz__back', 'data-cx-quiz-back': true, 'aria-label': copy.back, onclick: () => (index ? ask(index - 1) : intro()) }, [icon('back', 22)]),
        el('div', { className: 'cx-quiz__bar', 'aria-hidden': 'true' }, questions.map((item, position) => el('span', { className: position <= index ? 'is-done' : '' }))),
        el('div', { className: 'cx-quiz__count', 'aria-label': label, text: (index + 1) + ' / ' + questions.length })
      ]),
      el('h3', { className: 'cx-quiz__question', id: headingId, tabindex: '-1', 'data-cx-quiz-focus': true, text: question.title }),
      el('div', { className: 'cx-quiz__options', role: 'group', 'aria-labelledby': headingId },
        question.options.map(item => el('button', {
          type: 'button',
          className: 'cx-quiz__option' + (question.goal ? ' cx-quiz__option--goal' : ''),
          'data-cx-quiz-option': item.value,
          'aria-pressed': String(answers[question.key] === item.value),
          onclick: () => {
            answers[question.key] = item.value;
            save();
            if (index + 1 < questions.length) ask(index + 1);
            else finish();
          }
        }, [
          question.goal ? el('span', { className: 'cx-quiz__tile' }, [icon(item.icon, 22)]) : icon(item.icon, 22),
          el('span', { className: 'cx-quiz__option-text' }, [
            el('span', { text: item.label }),
            item.hint ? el('span', { className: 'cx-quiz__option-name' }, [el('span', { className: 'cx-quiz__dot', style: { background: products[item.value]?.dot || '#8a947c' } }), el('span', { text: item.hint })]) : null
          ]),
          el('span', { className: 'cx-quiz__ring' }, [icon('check', 16, 2)])
        ]))
      )
    ]));
    focusStage();
  };
  // A two-patch routine never pairs products that share an ingredient (valerian, damiana, gotu kola, ginseng, green tea).
  const pairFor = (goal, when) => ({ sleep: 'energy', energy: 'sleep', longevity: when === 'evening' ? 'energy' : 'sleep', menopause: 'longevity', 'male-vitality': 'longevity', 'ghk-cu': 'sleep', berberine: 'longevity' })[goal] || '';
  const restPopup = () => {
    set('localStorage', popupPrefix + 'goal', answers.goal);
    const state = get('localStorage', popupPrefix + 'state') || '';
    if (state === 'subscribed' || state === 'subscriber') return;
    const until = Date.now() + 14 * 86400000;
    if ((Number(get('localStorage', popupPrefix + 'until')) || 0) < until) set('localStorage', popupPrefix + 'until', until);
    set('localStorage', popupPrefix + 'state', 'dismissed');
  };
  const cartRegions = () => [...document.querySelectorAll('[data-cx-cart-region]')];
  const cartSections = () => [...new Set(cartRegions().map(region => region.dataset.sectionId).filter(Boolean))];
  // Mirrors the theme's cart rendering: the add response carries the cart sections.
  const renderCart = sections => {
    let changed = false;
    cartRegions().forEach(region => {
      const html = sections?.[region.dataset.sectionId];
      if (typeof html !== 'string') return;
      const content = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cx-cart-content]');
      if (!content) return;
      content.querySelectorAll('[data-cx-plan-controls], [data-cx-code-actions]').forEach(control => { control.hidden = false; });
      region.replaceChildren(content);
      document.querySelectorAll('[data-cx-count]').forEach(count => { count.textContent = content.dataset.itemCount; });
      changed = true;
    });
    return changed;
  };
  const addAll = async (button, handles) => {
    if (button.disabled) return;
    const status = stage.querySelector('[data-cx-quiz-cart-status]');
    const label = button.textContent;
    button.disabled = true;
    button.textContent = cartConfig.adding || label;
    if (status) status.textContent = '';
    try {
      if (window.CxCartCleanup?.ensure) await window.CxCartCleanup.ensure(cartConfig);
      const response = await fetch(cartConfig.add + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: handles.map(handle => ({ id: products[handle].variant, quantity: 1 })), sections: cartSections(), sections_url: location.pathname }) });
      const reply = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(reply.description || reply.message || '');
      signal('add');
      if (status) status.textContent = cartConfig.added || '';
      const opener = document.querySelector('[data-cx-cart-open]');
      if (renderCart(reply.sections) && opener) opener.click();
      else location.assign(cartConfig.cart);
    } catch (error) {
      if (status) status.textContent = error?.message || cartConfig.error || '';
    } finally {
      button.disabled = false;
      button.textContent = label;
    }
  };
  const show = () => {
    const goal = answers.goal;
    const product = products[goal];
    if (!product) { intro(); return; }
    const kit = data.kit || {};
    const inKit = ['sleep', 'energy', 'longevity'].includes(goal);
    const pair = answers.start === 'routine' ? pairFor(goal, answers.when) : '';
    const shop = (handle, primary) => el('a', { className: primary ? 'cx-quiz__primary' : 'cx-quiz__secondary', href: products[handle].url, text: text('shop', products[handle].title) });
    const lines = [];
    if (goal === 'sleep') lines.push(['moon', copy.line_when_sleep]);
    else if (goal === 'energy' && answers.when === 'evening') lines.push(['clock', copy.line_energy_evening]);
    else lines.push(['clock', copy['line_when_' + answers.when]]);
    lines.push(['patch', product.formatLine || copy['line_tried_' + answers.tried]]);
    const actions = [];
    const picks = [goal];
    if (pair && products[pair]) {
      picks.push(pair);
      lines.push(['pair', text('line_pair', products[pair].title) + ' ' + (data.combineRule || '')]);
      const buyable = cartConfig?.add && picks.every(handle => products[handle].available && products[handle].variant);
      if (buyable) actions.push(el('button', { type: 'button', className: 'cx-quiz__primary cx-quiz__add', 'data-cx-quiz-add': picks.join(','), text: picks.length === 2 ? copy.add_both : copy.add_all, onclick: event => addAll(event.currentTarget, picks) }));
      actions.push(shop(goal, !buyable), shop(pair, false));
    } else if (answers.start === 'try' && kit.eligible && inKit && kit.url) {
      if (kit.available) {
        lines.push(['tag', copy.line_kit]);
        actions.push(el('a', { className: 'cx-quiz__primary', href: kit.url, text: copy.kit_cta }), shop(goal, false));
      } else {
        lines.push(['tag', copy.line_kit_soldout]);
        actions.push(shop(goal, true), el('a', { className: 'cx-quiz__secondary', href: kit.url + '#CxDiscoveryInterest', text: copy.kit_waitlist }));
      }
    } else if (answers.start === 'try') {
      lines.push(['pouch', kit.eligible && kit.url ? text('line_kit_other', product.title) : copy.line_try_pouch]);
      actions.push(shop(goal, true));
    } else {
      actions.push(shop(goal, true));
    }
    const tint = product.tint || '#e7e2d6';
    card.dataset.view = 'result';
    const duo = picks.length > 1;
    const wearBlock = handle => el('div', { className: 'cx-quiz__wear' }, [
      el('p', { className: 'cx-quiz__label-small', text: duo ? data.wearTitle + ' · ' + products[handle].title : data.wearTitle }),
      el('dl', {}, [
        el('div', {}, [el('dt', { text: data.wearLabel }), el('dd', { text: products[handle].wear })]),
        products[handle].caution ? el('div', {}, [el('dt', { text: data.cautionLabel }), el('dd', { text: products[handle].caution })]) : null
      ])
    ]);
    stage.replaceChildren(el('div', { className: 'cx-quiz__result', 'data-cx-quiz-goal': goal, 'data-cx-quiz-picks': picks.join(',') }, [
      el('div', { className: 'cx-quiz__hero' + (duo ? ' cx-quiz__hero--duo' : ''), style: { background: tint } }, [
        el('div', { className: 'cx-quiz__hero-copy' }, [
          el('p', { className: 'cx-quiz__eyebrow', style: { color: product.ink || '#5f6b50' }, text: copy.match }),
          el('h3', { className: 'cx-quiz__name', tabindex: '-1', 'data-cx-quiz-focus': true, text: duo ? picks.map(handle => products[handle].name).join(' + ') : product.title }),
          !duo && product.subline ? el('p', { className: 'cx-quiz__pill', text: product.subline }) : null
        ]),
        duo
          ? el('div', { className: 'cx-quiz__duo' }, picks.map(handle => el('a', { className: 'cx-quiz__duo-item', href: products[handle].url, 'data-cx-quiz-pick': handle }, [
              products[handle].image ? el('img', { src: sized(products[handle].image, 480), alt: '', width: '148', height: '148', decoding: 'async' }) : null,
              el('span', { className: 'cx-quiz__duo-name', text: products[handle].title }),
              products[handle].subline ? el('span', { className: 'cx-quiz__duo-line', text: products[handle].subline }) : null
            ])))
          : (product.image ? el('img', { className: 'cx-quiz__photo', src: sized(product.image, 640), alt: '', width: '308', height: '308', decoding: 'async' }) : null)
      ]),
      el('div', { className: 'cx-quiz__body' }, [
        el('div', {}, [
          copy.why ? el('p', { className: 'cx-quiz__label-small', text: copy.why }) : null,
          el('ul', { className: 'cx-quiz__why' }, lines.filter(line => line[1]).map(line => el('li', {}, [el('span', { className: 'cx-quiz__why-icon', style: { background: tint } }, [icon(line[0], 18)]), el('p', { text: line[1].trim() })])))
        ]),
        el('div', { className: 'cx-quiz__wears' }, picks.map(wearBlock)),
        el('div', {}, [
          el('div', { className: 'cx-quiz__actions' }, actions),
          el('p', { className: 'cx-quiz__cart-status', 'data-cx-quiz-cart-status': true, role: 'status', 'aria-live': 'polite' })
        ]),
        el('div', { className: 'cx-quiz__after' }, [
          el('button', { type: 'button', className: 'cx-quiz__link', 'data-cx-quiz-restart': true, text: copy.restart, onclick: () => { answers = {}; save(); signal('restart'); ask(0); } }),
          data.compare ? el('a', { className: 'cx-quiz__link', href: '#compare-products', text: data.compare }) : null
        ])
      ])
    ]));
    signup.hidden = picks.includes('berberine') || (!ownResult && knownSubscriber());
  };
  const finish = () => {
    signal('result');
    restPopup();
    show();
    focusStage();
  };
  form.addEventListener('submit', () => {
    const tags = form.querySelector('[data-cx-quiz-tags]');
    if (tags) tags.value = 'newsletter,quiz' + (answers.goal && answers.goal !== 'menopause' && products[answers.goal] ? ',interest-' + answers.goal : '');
    set('sessionStorage', quizPrefix + 'pending', Date.now());
    save();
    signal('submit');
  });
  const copyButton = root.querySelector('[data-cx-quiz-copy]');
  copyButton?.addEventListener('click', async () => {
    if (copyButton.disabled) return;
    const code = root.querySelector('[data-cx-quiz-code]');
    const status = root.querySelector('[data-cx-quiz-copy-status]');
    copyButton.disabled = true;
    try {
      if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(code.textContent.trim());
      status.textContent = copyButton.dataset.copied;
    } catch {
      code.focus();
      const range = document.createRange();
      range.selectNodeContents(code);
      const selection = window.getSelection();
      selection?.removeAllRanges();
      selection?.addRange(range);
      status.textContent = copyButton.dataset.copyFailed;
    } finally { copyButton.disabled = false; }
  });
  if (complete()) {
    show();
    if (ownResult) {
      bringIntoView();
      const offerFocus = !signup.hidden && (root.querySelector('#cx-quiz-errors') || root.querySelector('[data-cx-quiz-code]'));
      (offerFocus || stage.querySelector('[data-cx-quiz-focus]'))?.focus({ preventScroll: true });
    }
  } else {
    intro();
    if (ownResult) signup.hidden = false;
  }
  if (location.hash === '#cx-quiz' || ownResult) requestAnimationFrame(bringIntoView);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cx-product-comparison"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = root => {
    if (root.dataset.comparisonReady) return;
    const scroller = root.querySelector('.cx-comparison__scroll');
    const table = scroller?.querySelector('table');
    const hint = root.querySelector('.cx-comparison__scroll-hint');
    if (!scroller || !table || !hint) return;
    root.dataset.comparisonReady = 'true';
    const update = () => {
      const overflow = scroller.scrollWidth > scroller.clientWidth + 1;
      hint.hidden = !overflow;
      if (overflow) {
        scroller.tabIndex = 0;
        scroller.setAttribute('aria-describedby', hint.id);
      } else {
        scroller.removeAttribute('tabindex');
        scroller.removeAttribute('aria-describedby');
      }
    };
    if (window.ResizeObserver) {
      const observer = new ResizeObserver(update);
      observer.observe(scroller);
      observer.observe(table);
    } else window.addEventListener('resize', update, {passive:true});
    document.fonts?.ready.then(update);
    requestAnimationFrame(update);
  };
  document.querySelectorAll('[data-cx-comparison]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-cx-comparison]').forEach(init));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cx-product-evidence"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = root => {
    if (root.dataset.evidenceReady) return;
    root.dataset.evidenceReady = 'true';
    root.addEventListener('click',event=>{
      const trigger=event.target.closest('[data-evidence-source]');
      if(trigger){const dialog=root.querySelector(`[data-evidence-dialog="${trigger.dataset.evidenceSource}"]`);if(dialog&&!dialog.open)dialog.showModal();}
      if(event.target.closest('[data-evidence-close]')) event.target.closest('dialog')?.close();
    });
    root.querySelectorAll('dialog').forEach(dialog=>dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();}));
  };
  document.querySelectorAll('[data-cx-evidence]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-cx-evidence]').forEach(init));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cx-product-quick-view"] && !Shopify.designMode) return;
  try {
    (() => {
  const instances = new Map();
  const syncScrollLock = () => document.documentElement.toggleAttribute('data-cx-quick-view-open', !!document.querySelector('[data-cx-quick-dialog][open]'));
  const init = root => {
    if (instances.has(root)) return;
    const trigger = root.querySelector('[data-cx-quick-open]');
    const template = root.querySelector('[data-cx-quick-template]');
    if (!trigger || !template || typeof HTMLDialogElement === 'undefined' || typeof HTMLDialogElement.prototype.showModal !== 'function') return;
    const controller = new AbortController();
    const {signal} = controller;
    const cardForm = root.closest('[data-cx-purchase-scope]')?.querySelector('cx-card-purchase form');
    let dialog = null;
    let awaitingCartReturn = false;
    const syncChoice = (source, target) => {
      const sourceSelect = source?.querySelector('select[name="selling_plan"]');
      const selected = sourceSelect ? sourceSelect.selectedOptions[0] : source?.querySelector('input[name="selling_plan"]:checked');
      if (!selected || selected.disabled || !target) return;
      const targetSelect = target.querySelector('select[name="selling_plan"]');
      if (targetSelect) {
        const matching = [...targetSelect.options].find(option => option.value === selected.value && !option.disabled);
        if (!matching || targetSelect.disabled || targetSelect.value === matching.value) return;
        targetSelect.value = matching.value;
        targetSelect.dispatchEvent(new Event('change', {bubbles:true}));
        return;
      }
      const matching = [...target.querySelectorAll('input[name="selling_plan"]')].find(input => input.value === selected.value && !input.disabled);
      if (!matching || matching.checked) return;
      matching.checked = true;
      matching.dispatchEvent(new Event('change', {bubbles:true}));
    };
    const mount = () => {
      if (dialog) return dialog;
      dialog = template.content.querySelector('[data-cx-quick-dialog]')?.cloneNode(true);
      if (!dialog) return null;
      document.body.appendChild(dialog);
      const tabs = [...dialog.querySelectorAll('[data-cx-quick-tab]')];
      const selectTab = selected => {
        tabs.forEach(tab => {
          const active = tab === selected;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          const panel = dialog.querySelector('#' + CSS.escape(tab.getAttribute('aria-controls')));
          if (panel) panel.hidden = !active;
        });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => selectTab(tab), {signal});
        tab.addEventListener('keydown', event => {
          if (!['ArrowRight','ArrowLeft','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const destination = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          selectTab(tabs[destination]);
          tabs[destination].focus();
        }, {signal});
      });
      dialog.querySelector('[data-cx-quick-close]')?.addEventListener('click', () => dialog.close(), {signal});
      dialog.addEventListener('cancel', event => { event.preventDefault(); dialog.close(); }, {signal});
      dialog.addEventListener('close', () => {
        syncScrollLock();
        if (trigger.isConnected && !document.querySelector('dialog[open]')) trigger.focus({preventScroll:true});
      }, {signal});
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      }, {signal});
      const cartDrawer = document.getElementById('cx-cart-drawer');
      dialog.querySelectorAll('.cx-product-form').forEach(form => form.addEventListener('cx:purchase-updated', () => {
        if (dialog.open && cartDrawer?.open) {
          awaitingCartReturn = true;
          dialog.close();
        }
      }, {signal}));
      dialog.addEventListener('change', event => {
        if (event.target.matches('input[name="selling_plan"], select[name="selling_plan"]')) syncChoice(event.target.form, cardForm);
      }, {signal});
      cartDrawer?.addEventListener('close', () => {
        if (!awaitingCartReturn) return;
        awaitingCartReturn = false;
        if (trigger.isConnected && !document.querySelector('dialog[open]')) trigger.focus({preventScroll:true});
      }, {signal});
      dialog.dispatchEvent(new CustomEvent('cx:quick-view-mounted', {bubbles:true, detail:{root:dialog}}));
      return dialog;
    };
    trigger.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      if (document.querySelector('dialog[open]')) return;
      const active = mount();
      if (!active) return;
      syncChoice(cardForm, active.querySelector('cx-card-purchase form'));
      try { active.showModal(); } catch (_) { return; }
      syncScrollLock();
      active.querySelector('[data-cx-quick-title]')?.focus({preventScroll:true});
      active.dispatchEvent(new CustomEvent('cx:quick-view-opened', {bubbles:true, detail:{root:active}}));
    }, {signal});
    trigger.hidden = false;
    instances.set(root, () => {
      controller.abort();
      if (dialog?.open) dialog.close();
      dialog?.remove();
      instances.delete(root);
      syncScrollLock();
    });
  };
  const initWithin = target => target.querySelectorAll('[data-cx-quick-view]').forEach(init);
  initWithin(document);
  document.addEventListener('shopify:section:load', event => initWithin(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, destroy] of instances) if (event.target.contains(root)) destroy();
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cx-review-carousel"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = root => {
    if (root.dataset.cxReviewInitialized) return;
    root.dataset.cxReviewInitialized = 'true';
    const native = root.querySelector('[data-cx-review-native]');
    const cards = root.querySelector('[data-cx-review-cards]');
    const dialog = root.querySelector('[data-cx-review-dialog]');
    const full = root.querySelector('[data-cx-review-full]');
    const track = root.querySelector('[data-cx-review-track]');
    const labels = root.querySelector('[data-cx-review-labels]').dataset;
    const allURL = new URL(window.location.href);
    allURL.searchParams.set('cx_reviews','all');
    allURL.hash = 'CxReviews';
    root.querySelectorAll('[data-cx-review-all]').forEach(link => { link.href = allURL.href; });
    const showNative = () => {
      cards.hidden = true;
      native.hidden = false;
      root.dataset.cxReviewsFull = 'true';
      if (dialog.open) dialog.close();
      if (window.location.hash === '#judgeme_product_reviews') requestAnimationFrame(() => root.scrollIntoView({block:'start'}));
    };
    const nativeRequested = () => new URLSearchParams(window.location.search).get('cx_reviews') === 'all' || new URLSearchParams(window.location.search).has('judgeme_review_uuid') || window.location.hash === '#judgeme_product_reviews';
    const onHashChange = () => { if (nativeRequested()) showNative(); };
    root.addEventListener('shopify:block:select', showNative);
    if (nativeRequested()) { showNative(); return; }
    if (typeof dialog.showModal !== 'function') return;
    let data;
    try { data = JSON.parse(root.querySelector('[data-cx-review-data]').content.textContent); } catch (_) { return; }
    if (!data || String(data.product_external_id) !== root.dataset.productId || !Array.isArray(data.reviews) || !data.reviews.length) return;
    const valid = review => review && typeof review.uuid === 'string' && review.uuid.length > 0 && typeof review.body === 'string' && typeof review.title === 'string' && typeof review.reviewer_name === 'string' && typeof review.is_anonymous_reviewer === 'boolean' && typeof review.verified_buyer === 'boolean' && Number.isInteger(review.rating) && review.rating >= 1 && review.rating <= 5 && Array.isArray(review.transparency_badges) && review.transparency_badges.every(badge => ['review_collected_via_store_invitation','review_collected_from_store_visitor'].includes(badge));
    if (!data.reviews.every(valid)) return;
    window.addEventListener('hashchange', onHashChange);
    const seen = new Set();
    const reviews = data.reviews.filter(review => { if (seen.has(review.uuid)) return false; seen.add(review.uuid); return true; });
    const element = (tag, className, text) => { const node = document.createElement(tag); node.className = className; if (text !== undefined) node.textContent = text; return node; };
    const reviewContent = review => {
      const fragment = document.createDocumentFragment();
      const stars = element('p','cx-review-carousel__stars','★'.repeat(review.rating) + '☆'.repeat(5-review.rating));
      stars.setAttribute('role','img'); stars.setAttribute('aria-label',labels.rating.replace('__rating__',String(review.rating))); fragment.append(stars);
      if (review.title) fragment.append(element('h3','jdgm-rev__title',review.title));
      fragment.append(element('p','cx-review-carousel__body jdgm-rev__body',review.body));
      fragment.append(element('p','cx-review-carousel__byline',review.is_anonymous_reviewer ? labels.anonymous : review.reviewer_name));
      const meta = element('p','cx-review-carousel__meta');
      if (typeof review.product_title === 'string' && review.product_title) meta.append(element('span','',review.product_title));
      const date = new Date(typeof review.created_at === 'string' ? review.created_at : NaN);
      if (Number.isFinite(date.getTime())) { const time = element('time','',date.toLocaleDateString(root.dataset.locale || 'en',{day:'numeric',month:'short',year:'numeric'})); time.dateTime = date.toISOString(); meta.append(time); }
      if (meta.childNodes.length) fragment.append(meta);
      if (review.verified_buyer) fragment.append(element('p','cx-review-carousel__provenance',labels.verified));
      if (review.transparency_badges.includes('review_collected_via_store_invitation')) fragment.append(element('p','cx-review-carousel__provenance',labels.invited));
      if (review.transparency_badges.includes('review_collected_from_store_visitor')) fragment.append(element('p','cx-review-carousel__provenance',labels.visitor));
      return fragment;
    };
    let opener;
    reviews.forEach(review => {
      const card = element('article','cx-review-carousel__card'); card.dataset.reviewId = review.uuid; card.append(reviewContent(review));
      const button = element('button','cx-review-carousel__read',labels.read); button.type = 'button';
      button.addEventListener('click', () => { opener = button; full.replaceChildren(reviewContent(review)); dialog.showModal(); });
      card.append(button); track.append(card);
    });
    root.querySelector('[data-cx-review-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target !== dialog) return; const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); });
    dialog.addEventListener('close', () => { full.replaceChildren(); if (opener?.isConnected) opener.focus({preventScroll:true}); });
    const previous = root.querySelector('[data-cx-review-prev]');
    const next = root.querySelector('[data-cx-review-next]');
    const position = root.querySelector('[data-cx-review-position]');
    const items = Array.from(track.children);
    let frame;
    const update = () => {
      frame = null;
      const overflow = track.scrollWidth > track.clientWidth + 2;
      root.querySelector('[data-cx-review-controls]').hidden = !overflow;
      root.querySelector('[data-cx-review-hint]').hidden = !overflow;
      const start = track.getBoundingClientRect().left;
      let current = 0;
      let closest = Infinity;
      items.forEach((item,index) => { const distance = Math.abs(item.getBoundingClientRect().left-start); if (distance < closest) { closest = distance; current = index; } });
      const scroll = Math.abs(track.scrollLeft);
      previous.disabled = !overflow || scroll < 2;
      next.disabled = !overflow || scroll + track.clientWidth >= track.scrollWidth - 2;
      const description = labels.position.replace('__current__',String(current+1)).replace('__total__',String(items.length));
      if (position.textContent !== description) position.textContent = description;
    };
    const scroll = direction => { const step = track.firstElementChild.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0); track.scrollBy({left:step*direction,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}); };
    previous.addEventListener('click', () => scroll(-1)); next.addEventListener('click', () => scroll(1));
    track.addEventListener('keydown', event => { if (event.target !== track || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return; event.preventDefault(); if (event.key === 'Home' || event.key === 'End') track.scrollTo({left:event.key === 'Home'?0:track.scrollWidth,behavior:'auto'}); else scroll(event.key === 'ArrowRight'?1:-1); });
    const scheduleUpdate = () => { if (frame == null) frame = requestAnimationFrame(update); };
    track.addEventListener('scroll', scheduleUpdate,{passive:true});
    window.addEventListener('resize', scheduleUpdate);
    const resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(scheduleUpdate) : null;
    resizeObserver?.observe(track);
    const onUnload = event => {
      if (event.target !== root && !event.target.contains(root)) return;
      window.removeEventListener('resize', scheduleUpdate);
      window.removeEventListener('hashchange', onHashChange);
      resizeObserver?.disconnect();
      if (frame != null) cancelAnimationFrame(frame);
      document.removeEventListener('shopify:section:unload', onUnload);
    };
    document.addEventListener('shopify:section:unload', onUnload);
    native.hidden = true; cards.hidden = false; root.dataset.cxReviewsReady = 'true';
    scheduleUpdate();
  };
  const scan = scope => { if (scope.matches?.('[data-cx-review-carousel]')) initialize(scope); scope.querySelectorAll('[data-cx-review-carousel]').forEach(initialize); };
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cx-review-presentation"] && !Shopify.designMode) return;
  try {
    (() => {
  const selector = '.jdgm-rev__body,.jdgm-rev__title,.jdgm-carousel-item__review-body,.jdgm-carousel-item__review-title';
  const rootSelector = '[data-cx-review-carousel],.jdgm-widget,.jdgm-carousel-wrapper';
  const observed = new WeakSet();
  const emoji = /(?:\p{Regional_Indicator}{2}|[#*0-9]\uFE0F?\u20E3|\p{Extended_Pictographic}(?:[\uFE0E\uFE0F]|\p{Emoji_Modifier})?(?:\u200D\p{Extended_Pictographic}(?:[\uFE0E\uFE0F]|\p{Emoji_Modifier})?)*)/gu;
  const clean = element => {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const value = node.nodeValue.replace(emoji, match => /^[©®™][\uFE0E\uFE0F]?$/.test(match) ? match.replace(/[\uFE0E\uFE0F]/g, '') : ' ');
      if (value !== node.nodeValue) node.nodeValue = value;
    }
  };
  const scan = node => {
    const element = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
    if (!element) return;
    const review = element.closest(selector);
    if (review) clean(review);
    element.querySelectorAll(selector).forEach(clean);
  };
  const observer = new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'characterData') scan(record.target);
      else record.addedNodes.forEach(scan);
    }
  });
  const observeRoot = root => {
    if (observed.has(root) || root.parentElement?.closest(rootSelector)) return;
    observed.add(root);
    scan(root);
    observer.observe(root, {childList:true, subtree:true, characterData:true});
  };
  const discover = node => {
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    if (node.matches(rootSelector)) observeRoot(node);
    node.querySelectorAll(rootSelector).forEach(observeRoot);
  };
  discover(document.body);
  const discovery = new MutationObserver(records => {
    for (const record of records) {
      if (!record.target.closest(rootSelector)) record.addedNodes.forEach(discover);
    }
  });
  discovery.observe(document.body, {childList:true, subtree:true});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cx-review-rating"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = link => {
    if (link.dataset.cxRatingReady) return;
    const display = link.querySelector('[data-cx-rating-display]');
    if (!display) return;
    link.dataset.cxRatingReady = 'true';
    const sync = () => {
      display.querySelectorAll('[tabindex]').forEach(node => node.removeAttribute('tabindex'));
      display.querySelectorAll('[role="button"],[role="link"]').forEach(node => node.removeAttribute('role'));
      const rawScore = display.querySelector('.jdgm-prev-badge__stars')?.getAttribute('data-score');
      const score = rawScore === null || rawScore === undefined || rawScore.trim() === '' ? NaN : Number(rawScore);
      const summary = display.querySelector('.jdgm-prev-badge__text')?.textContent.trim();
      const labels = [link.dataset.cxRatingLabel];
      if (Number.isFinite(score) && score >= 0 && score <= 5) {
        const formatted = new Intl.NumberFormat(document.documentElement.lang || 'en', { maximumFractionDigits: 2 }).format(score);
        labels.push(link.dataset.cxRatingScoreLabel.replace('__rating__', formatted));
      }
      if (summary) labels.push(summary);
      const label = labels.filter(Boolean).join('. ');
      if (link.getAttribute('aria-label') !== label) link.setAttribute('aria-label', label);
    };
    sync();
    const observer = new MutationObserver(sync);
    observer.observe(display, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['role', 'tabindex', 'data-score'] });
    const unload = event => {
      if (!event.target.contains(link)) return;
      observer.disconnect();
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
  };
  document.querySelectorAll('.cx-review-rating').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.cx-review-rating').forEach(init));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cx-subscription-prompt"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('cx-subscription-prompt');
  if (!dialog || typeof dialog.showModal !== 'function' || typeof HTMLFormElement.prototype.requestSubmit !== 'function') return;
  const key = 'cx-subscription-offer:v1';
  const bypass = new WeakSet();
  let pending = null;
  let shown = false;
  try { shown = sessionStorage.getItem(key) === 'shown'; } catch (_) {}
  const hasBeenShown = () => { if (!shown) { try { shown = sessionStorage.getItem(key) === 'shown'; } catch (_) {} } return shown; };
  const markShown = () => { shown = true; try { sessionStorage.setItem(key, 'shown'); } catch (_) {} };
  const snapshot = form => ({id:String(new FormData(form).get('id') || ''),quantity:Number(new FormData(form).get('quantity') || 1),plan:String(new FormData(form).get('selling_plan') || '')});
  const finish = choice => {
    const current = pending;
    pending = null;
    if (dialog.open) dialog.close();
    if (!current) return;
    const {form,button,item,offer} = current;
    if (!choice) { button?.focus({preventScroll:true}); return; }
    const next = snapshot(form);
    if (!form.isConnected || next.id !== item.id || next.quantity !== item.quantity || next.plan !== item.plan || form.dataset.busy || button?.disabled || document.documentElement.hasAttribute('data-cx-cart-needs-reload') || !form.checkValidity()) { button?.focus({preventScroll:true}); return; }
    let temporary = null;
    if (choice === 'subscription') {
      const radio = [...form.querySelectorAll('input[name="selling_plan"]')].find(input => input.value === offer.planId);
      if (radio) {
        if (radio.type !== 'radio' || radio.disabled) { button?.focus({preventScroll:true}); return; }
        radio.checked = true;
        radio.dispatchEvent(new Event('change', {bubbles:true}));
      } else {
        if (form.querySelector('[name="selling_plan"]')) { button?.focus({preventScroll:true}); return; }
        temporary = document.createElement('input');
        temporary.type = 'hidden'; temporary.name = 'selling_plan'; temporary.value = offer.planId;
        form.appendChild(temporary);
      }
    }
    bypass.add(form);
    try { form.requestSubmit(button || undefined); }
    finally { bypass.delete(form); temporary?.remove(); }
  };
  dialog.querySelector('[data-cx-sub-accept]').addEventListener('click', () => finish('subscription'));
  dialog.querySelector('[data-cx-sub-once]').addEventListener('click', () => finish('once'));
  dialog.querySelector('[data-cx-sub-close]').addEventListener('click', () => finish(null));
  dialog.addEventListener('cancel', event => { event.preventDefault(); finish(null); });
  dialog.addEventListener('close', () => { if (pending) finish(null); });
  dialog.addEventListener('click', event => { if (event.target === dialog) finish(null); });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('.cx-product-form') || event.defaultPrevented || bypass.has(form)) return;
    if (pending) { event.preventDefault(); event.stopImmediatePropagation(); return; }
    if (hasBeenShown() || form.dataset.busy || document.documentElement.hasAttribute('data-cx-cart-needs-reload') || document.querySelector('[data-cx-cart-content][aria-busy="true"]')) return;
    const source = form.querySelector('[data-cx-sub-offer]');
    if (!source || !form.checkValidity()) return;
    const item = snapshot(form);
    const offer = source.dataset;
    const once = Number(offer.onceCents), subscription = Number(offer.subCents), quantity = item.quantity;
    if (item.plan || item.id !== offer.variantId || !Number.isSafeInteger(quantity) || quantity < 1 || !Number.isSafeInteger(once * quantity) || !Number.isSafeInteger(subscription * quantity) || subscription <= 0 || subscription >= once || !/^\d+$/.test(offer.planId)) return;
    if (document.querySelector('dialog[open]')) return;
    let values;
    try {
      const formatter = new Intl.NumberFormat(offer.locale || 'en', {style:'currency',currency:offer.currency});
      const scale = 10 ** Math.max(2, formatter.resolvedOptions().maximumFractionDigits);
      values = {percent:offer.percent, product:offer.productTitle, count:String(quantity), subscription:quantity === 1 ? offer.subMoney : formatter.format(subscription * quantity / scale), once:quantity === 1 ? offer.onceMoney : formatter.format(once * quantity / scale), saving:quantity === 1 ? offer.saveMoney : formatter.format((once - subscription) * quantity / scale)};
    } catch (_) { return; }
    dialog.querySelectorAll('[data-cx-sub-template]').forEach(node => {
      node.textContent = node.dataset.cxSubTemplate.replace(/__(percent|product|count|subscription|once|saving)__/g, (_,name) => values[name]);
    });
    try { dialog.showModal(); } catch (_) { return; }
    event.preventDefault();
    event.stopImmediatePropagation();
    pending = {form,button:event.submitter || form.querySelector('[type="submit"]'),item,offer};
    markShown();
    dialog.querySelector('#cx-sub-title').focus();
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
